import type { IconName } from "@subframe/core";

export type LazyIconName = keyof typeof iconMap;

export const iconMap: Record<NonNullable<IconName>, string | null> = {
  FeatherAArrowDown: "a-arrow-down",
  FeatherAArrowUp: "a-arrow-up",
  FeatherALargeSmall: "a-large-small",
  FeatherAccessibility: "accessibility",
  FeatherActivitySquare: "activity-square",
  FeatherActivity: "activity",
  FeatherAirVent: "air-vent",
  FeatherAirplay: "airplay",
  FeatherAlarmCheck: "alarm-check",
  FeatherAlarmClockOff: "alarm-clock-off",
  FeatherAlarmClock: "alarm-clock",
  FeatherAlarmMinus: "alarm-minus",
  FeatherAlarmPlus: "alarm-plus",
  FeatherAlarmSmoke: "alarm-smoke",
  FeatherAlbum: "album",
  FeatherAlertCircle: "alert-circle",
  FeatherAlertOctagon: "alert-octagon",
  FeatherAlertTriangle: "alert-triangle",
  FeatherAlignCenterHorizontal: "align-center-horizontal",
  FeatherAlignCenterVertical: "align-center-vertical",
  FeatherAlignCenter: "align-center",
  FeatherAlignEndHorizontal: "align-end-horizontal",
  FeatherAlignEndVertical: "align-end-vertical",
  FeatherAlignHBottomLeft: "align-h-bottom-left",
  FeatherAlignHBottomRight: "align-h-bottom-right",
  FeatherAlignHBottom: "align-h-bottom",
  FeatherAlignHCenter: "align-h-center",
  FeatherAlignHLeft: "align-h-left",
  FeatherAlignHRight: "align-h-right",
  FeatherAlignHTopLeft: "align-h-top-left",
  FeatherAlignHTopRight: "align-h-top-right",
  FeatherAlignHTop: "align-h-top",
  FeatherAlignHorizontalDistributeCenter: "align-horizontal-distribute-center",
  FeatherAlignHorizontalDistributeEnd: "align-horizontal-distribute-end",
  FeatherAlignHorizontalDistributeStart: "align-horizontal-distribute-start",
  FeatherAlignHorizontalJustifyCenter: "align-horizontal-justify-center",
  FeatherAlignHorizontalJustifyEnd: "align-horizontal-justify-end",
  FeatherAlignHorizontalJustifyStart: "align-horizontal-justify-start",
  FeatherAlignHorizontalSpaceAround: "align-horizontal-space-around",
  FeatherAlignHorizontalSpaceBetween: "align-horizontal-space-between",
  FeatherAlignJustify: "align-justify",
  FeatherAlignLeft: "align-left",
  FeatherAlignRight: "align-right",
  FeatherAlignStartHorizontal: "align-start-horizontal",
  FeatherAlignStartVertical: "align-start-vertical",
  FeatherAlignVBottomLeft: "align-v-bottom-left",
  FeatherAlignVBottomRight: "align-v-bottom-right",
  FeatherAlignVBottom: "align-v-bottom",
  FeatherAlignVCenter: "align-v-center",
  FeatherAlignVLeft: "align-v-left",
  FeatherAlignVRight: "align-v-right",
  FeatherAlignVTopLeft: "align-v-top-left",
  FeatherAlignVTopRight: "align-v-top-right",
  FeatherAlignVTop: "align-v-top",
  FeatherAlignVerticalDistributeCenter: "align-vertical-distribute-center",
  FeatherAlignVerticalDistributeEnd: "align-vertical-distribute-end",
  FeatherAlignVerticalDistributeStart: "align-vertical-distribute-start",
  FeatherAlignVerticalJustifyCenter: "align-vertical-justify-center",
  FeatherAlignVerticalJustifyEnd: "align-vertical-justify-end",
  FeatherAlignVerticalJustifyStart: "align-vertical-justify-start",
  FeatherAlignVerticalSpaceAround: "align-vertical-space-around",
  FeatherAlignVerticalSpaceBetween: "align-vertical-space-between",
  FeatherAmbulance: "ambulance",
  FeatherAmpersand: "ampersand",
  FeatherAmpersands: "ampersands",
  FeatherAmphora: "amphora",
  FeatherAnchor: "anchor",
  FeatherAngry: "angry",
  FeatherAnnoyed: "annoyed",
  FeatherAntenna: "antenna",
  FeatherAnvil: "anvil",
  FeatherAperture: "aperture",
  FeatherAppWindowMac: "app-window-mac",
  FeatherAppWindow: "app-window",
  FeatherApple: "apple",
  FeatherArchiveRestore: "archive-restore",
  FeatherArchiveX: "archive-x",
  FeatherArchive: "archive",
  FeatherAreaChart: "area-chart",
  FeatherArmchair: "armchair",
  FeatherArrowBigDownDash: "arrow-big-down-dash",
  FeatherArrowBigDown: "arrow-big-down",
  FeatherArrowBigLeftDash: "arrow-big-left-dash",
  FeatherArrowBigLeft: "arrow-big-left",
  FeatherArrowBigRightDash: "arrow-big-right-dash",
  FeatherArrowBigRight: "arrow-big-right",
  FeatherArrowBigUpDash: "arrow-big-up-dash",
  FeatherArrowBigUp: "arrow-big-up",
  FeatherArrowDown01: "arrow-down-0-1",
  FeatherArrowDown10: "arrow-down-1-0",
  FeatherArrowDownAZ: "arrow-down-a-z",
  FeatherArrowDownCircle: "arrow-down-circle",
  FeatherArrowDownFromLine: "arrow-down-from-line",
  FeatherArrowDownLeftFromCircle: "arrow-down-left-from-circle",
  FeatherArrowDownLeftSquare: "arrow-down-left-square",
  FeatherArrowDownLeft: "arrow-down-left",
  FeatherArrowDownNarrowWide: "arrow-down-narrow-wide",
  FeatherArrowDownRightFromCircle: "arrow-down-right-from-circle",
  FeatherArrowDownRightSquare: "arrow-down-right-square",
  FeatherArrowDownRight: "arrow-down-right",
  FeatherArrowDownSquare: "arrow-down-square",
  FeatherArrowDownToDot: "arrow-down-to-dot",
  FeatherArrowDownToLine: "arrow-down-to-line",
  FeatherArrowDownUp: "arrow-down-up",
  FeatherArrowDownWideNarrow: "arrow-down-wide-narrow",
  FeatherArrowDownZA: "arrow-down-z-a",
  FeatherArrowDown: "arrow-down",
  FeatherArrowLeftCircle: "arrow-left-circle",
  FeatherArrowLeftFromLine: "arrow-left-from-line",
  FeatherArrowLeftRight: "arrow-left-right",
  FeatherArrowLeftSquare: "arrow-left-square",
  FeatherArrowLeftToLine: "arrow-left-to-line",
  FeatherArrowLeft: "arrow-left",
  FeatherArrowRightCircle: "arrow-right-circle",
  FeatherArrowRightFromLine: "arrow-right-from-line",
  FeatherArrowRightLeft: "arrow-right-left",
  FeatherArrowRightSquare: "arrow-right-square",
  FeatherArrowRightToLine: "arrow-right-to-line",
  FeatherArrowRight: "arrow-right",
  FeatherArrowUp01: "arrow-up-0-1",
  FeatherArrowUp10: "arrow-up-1-0",
  FeatherArrowUpAZ: "arrow-up-a-z",
  FeatherArrowUpCircle: "arrow-up-circle",
  FeatherArrowUpDown: "arrow-up-down",
  FeatherArrowUpFromDot: "arrow-up-from-dot",
  FeatherArrowUpFromLine: "arrow-up-from-line",
  FeatherArrowUpLeftFromCircle: "arrow-up-left-from-circle",
  FeatherArrowUpLeftSquare: "arrow-up-left-square",
  FeatherArrowUpLeft: "arrow-up-left",
  FeatherArrowUpNarrowWide: "arrow-up-narrow-wide",
  FeatherArrowUpRightFromCircle: "arrow-up-right-from-circle",
  FeatherArrowUpRightSquare: "arrow-up-right-square",
  FeatherArrowUpRight: "arrow-up-right",
  FeatherArrowUpSquare: "arrow-up-square",
  FeatherArrowUpToLine: "arrow-up-to-line",
  FeatherArrowUpWideNarrow: "arrow-up-wide-narrow",
  FeatherArrowUpZA: "arrow-up-z-a",
  FeatherArrowUp: "arrow-up",
  FeatherArrowsUpFromLine: "arrows-up-from-line",
  FeatherAsterisk: "asterisk",
  FeatherAtSign: "at-sign",
  FeatherAtom: "atom",
  FeatherAudioLines: "audio-lines",
  FeatherAudioWaveform: "audio-waveform",
  FeatherAward: "award",
  FeatherAxe: "axe",
  FeatherAxis3D: "axis-3d",
  FeatherBaby: "baby",
  FeatherBackpack: "backpack",
  FeatherBadgeAlert: "badge-alert",
  FeatherBadgeCent: "badge-cent",
  FeatherBadgeCheck: "badge-check",
  FeatherBadgeDollarSign: "badge-dollar-sign",
  FeatherBadgeEuro: "badge-euro",
  FeatherBadgeHelp: "badge-help",
  FeatherBadgeIndianRupee: "badge-indian-rupee",
  FeatherBadgeInfo: "badge-info",
  FeatherBadgeJapaneseYen: "badge-japanese-yen",
  FeatherBadgeMinus: "badge-minus",
  FeatherBadgePercent: "badge-percent",
  FeatherBadgePlus: "badge-plus",
  FeatherBadgePoundSterling: "badge-pound-sterling",
  FeatherBadgeRussianRuble: "badge-russian-ruble",
  FeatherBadgeSwissFranc: "badge-swiss-franc",
  FeatherBadgeX: "badge-x",
  FeatherBadge: "badge",
  FeatherBaggageClaim: "baggage-claim",
  FeatherBan: "ban",
  FeatherBanana: "banana",
  FeatherBandage: "bandage",
  FeatherBanknoteArrowDown: "banknote-arrow-down",
  FeatherBanknoteArrowUp: "banknote-arrow-up",
  FeatherBanknoteX: "banknote-x",
  FeatherBanknote: "banknote",
  FeatherBarChart2: "bar-chart-2",
  FeatherBarChart3: "bar-chart-3",
  FeatherBarChart4: "bar-chart-4",
  FeatherBarChartBig: "bar-chart-big",
  FeatherBarChartHorizontalBig: "bar-chart-horizontal-big",
  FeatherBarChartHorizontal: "bar-chart-horizontal",
  FeatherBarChart: "bar-chart",
  FeatherBarcode: "barcode",
  FeatherBarrel: "barrel",
  FeatherBaseline: "baseline",
  FeatherBath: "bath",
  FeatherBatteryCharging: "battery-charging",
  FeatherBatteryFull: "battery-full",
  FeatherBatteryLow: "battery-low",
  FeatherBatteryMedium: "battery-medium",
  FeatherBatteryPlus: "battery-plus",
  FeatherBatteryWarning: "battery-warning",
  FeatherBattery: "battery",
  FeatherBeaker: "beaker",
  FeatherBeanOff: "bean-off",
  FeatherBean: "bean",
  FeatherBedDouble: "bed-double",
  FeatherBedSingle: "bed-single",
  FeatherBed: "bed",
  FeatherBeef: "beef",
  FeatherBeerOff: "beer-off",
  FeatherBeer: "beer",
  FeatherBellDot: "bell-dot",
  FeatherBellElectric: "bell-electric",
  FeatherBellMinus: "bell-minus",
  FeatherBellOff: "bell-off",
  FeatherBellPlus: "bell-plus",
  FeatherBellRing: "bell-ring",
  FeatherBell: "bell",
  FeatherBetweenHorizontalEnd: "between-horizontal-end",
  FeatherBetweenHorizontalStart: "between-horizontal-start",
  FeatherBetweenVerticalEnd: "between-vertical-end",
  FeatherBetweenVerticalStart: "between-vertical-start",
  FeatherBicepsFlexed: "biceps-flexed",
  FeatherBike: "bike",
  FeatherBinary: "binary",
  FeatherBinoculars: "binoculars",
  FeatherBiohazard: "biohazard",
  FeatherBird: "bird",
  FeatherBitcoin: "bitcoin",
  FeatherBlend: "blend",
  FeatherBlinds: "blinds",
  FeatherBlocks: "blocks",
  FeatherBluetoothConnected: "bluetooth-connected",
  FeatherBluetoothOff: "bluetooth-off",
  FeatherBluetoothSearching: "bluetooth-searching",
  FeatherBluetooth: "bluetooth",
  FeatherBold: "bold",
  FeatherBolt: "bolt",
  FeatherBomb: "bomb",
  FeatherBone: "bone",
  FeatherBookA: "book-a",
  FeatherBookAlert: "book-alert",
  FeatherBookAudio: "book-audio",
  FeatherBookCheck: "book-check",
  FeatherBookCopy: "book-copy",
  FeatherBookDashed: "book-dashed",
  FeatherBookDown: "book-down",
  FeatherBookHeadphones: "book-headphones",
  FeatherBookHeart: "book-heart",
  FeatherBookImage: "book-image",
  FeatherBookKey: "book-key",
  FeatherBookLock: "book-lock",
  FeatherBookMarked: "book-marked",
  FeatherBookMinus: "book-minus",
  FeatherBookOpenCheck: "book-open-check",
  FeatherBookOpenText: "book-open-text",
  FeatherBookOpen: "book-open",
  FeatherBookPlus: "book-plus",
  FeatherBookText: "book-text",
  FeatherBookType: "book-type",
  FeatherBookUp2: "book-up-2",
  FeatherBookUp: "book-up",
  FeatherBookUser: "book-user",
  FeatherBookX: "book-x",
  FeatherBook: "book",
  FeatherBookmarkCheck: "bookmark-check",
  FeatherBookmarkMinus: "bookmark-minus",
  FeatherBookmarkPlus: "bookmark-plus",
  FeatherBookmarkX: "bookmark-x",
  FeatherBookmark: "bookmark",
  FeatherBoomBox: "boom-box",
  FeatherBotMessageSquare: "bot-message-square",
  FeatherBotOff: "bot-off",
  FeatherBot: "bot",
  FeatherBottleWine: "bottle-wine",
  FeatherBowArrow: "bow-arrow",
  FeatherBoxSelect: "box-select",
  FeatherBox: "box",
  FeatherBoxes: "boxes",
  FeatherBraces: "braces",
  FeatherBrackets: "brackets",
  FeatherBrainCircuit: "brain-circuit",
  FeatherBrainCog: "brain-cog",
  FeatherBrain: "brain",
  FeatherBrickWallFire: "brick-wall-fire",
  FeatherBrickWall: "brick-wall",
  FeatherBriefcaseBusiness: "briefcase-business",
  FeatherBriefcaseConveyorBelt: "briefcase-conveyor-belt",
  FeatherBriefcaseMedical: "briefcase-medical",
  FeatherBriefcase: "briefcase",
  FeatherBringToFront: "bring-to-front",
  FeatherBrushCleaning: "brush-cleaning",
  FeatherBrush: "brush",
  FeatherBubbles: "bubbles",
  FeatherBugOff: "bug-off",
  FeatherBugPlay: "bug-play",
  FeatherBug: "bug",
  FeatherBuilding2: "building-2",
  FeatherBuilding: "building",
  FeatherBusFront: "bus-front",
  FeatherBus: "bus",
  FeatherCableCar: "cable-car",
  FeatherCable: "cable",
  FeatherCakeSlice: "cake-slice",
  FeatherCake: "cake",
  FeatherCalculator: "calculator",
  FeatherCalendar1: "calendar-1",
  FeatherCalendarArrowDown: "calendar-arrow-down",
  FeatherCalendarArrowUp: "calendar-arrow-up",
  FeatherCalendarCheck2: "calendar-check-2",
  FeatherCalendarCheck: "calendar-check",
  FeatherCalendarClock: "calendar-clock",
  FeatherCalendarCog: "calendar-cog",
  FeatherCalendarDays: "calendar-days",
  FeatherCalendarFold: "calendar-fold",
  FeatherCalendarHeart: "calendar-heart",
  FeatherCalendarMinus2: "calendar-minus-2",
  FeatherCalendarMinus: "calendar-minus",
  FeatherCalendarOff: "calendar-off",
  FeatherCalendarPlus2: "calendar-plus-2",
  FeatherCalendarPlus: "calendar-plus",
  FeatherCalendarRange: "calendar-range",
  FeatherCalendarSearch: "calendar-search",
  FeatherCalendarSync: "calendar-sync",
  FeatherCalendarX2: "calendar-x-2",
  FeatherCalendarX: "calendar-x",
  FeatherCalendar: "calendar",
  FeatherCameraOff: "camera-off",
  FeatherCamera: "camera",
  FeatherCandlestickChart: "candlestick-chart",
  FeatherCandyCane: "candy-cane",
  FeatherCandyOff: "candy-off",
  FeatherCandy: "candy",
  FeatherCannabis: "cannabis",
  FeatherCaptionsOff: "captions-off",
  FeatherCaptions: "captions",
  FeatherCarFront: "car-front",
  FeatherCarTaxiFront: "car-taxi-front",
  FeatherCar: "car",
  FeatherCaravan: "caravan",
  FeatherCardSim: "card-sim",
  FeatherCarrot: "carrot",
  FeatherCaseLower: "case-lower",
  FeatherCaseSensitive: "case-sensitive",
  FeatherCaseUpper: "case-upper",
  FeatherCassetteTape: "cassette-tape",
  FeatherCast: "cast",
  FeatherCastle: "castle",
  FeatherCat: "cat",
  FeatherCctv: "cctv",
  FeatherChartArea: "chart-area",
  FeatherChartBarBig: "chart-bar-big",
  FeatherChartBarDecreasing: "chart-bar-decreasing",
  FeatherChartBarIncreasing: "chart-bar-increasing",
  FeatherChartBarStacked: "chart-bar-stacked",
  FeatherChartBar: "chart-bar",
  FeatherChartCandlestick: "chart-candlestick",
  FeatherChartColumnBig: "chart-column-big",
  FeatherChartColumnDecreasing: "chart-column-decreasing",
  FeatherChartColumnIncreasing: "chart-column-increasing",
  FeatherChartColumnStacked: "chart-column-stacked",
  FeatherChartColumn: "chart-column",
  FeatherChartGantt: "chart-gantt",
  FeatherChartLine: "chart-line",
  FeatherChartNetwork: "chart-network",
  FeatherChartNoAxesColumnDecreasing: "chart-no-axes-column-decreasing",
  FeatherChartNoAxesCombined: "chart-no-axes-combined",
  FeatherChartPie: "chart-pie",
  FeatherChartScatter: "chart-scatter",
  FeatherChartSpline: "chart-spline",
  FeatherCheckCheck: "check-check",
  FeatherCheckCircle2: "check-circle-2",
  FeatherCheckCircle: "check-circle",
  FeatherCheckLine: "check-line",
  FeatherCheckSquare: "check-square",
  FeatherCheck: "check",
  FeatherChefHat: "chef-hat",
  FeatherCherry: "cherry",
  FeatherChevronDownCircle: "chevron-down-circle",
  FeatherChevronDownSquare: "chevron-down-square",
  FeatherChevronDown: "chevron-down",
  FeatherChevronFirst: "chevron-first",
  FeatherChevronLast: "chevron-last",
  FeatherChevronLeftCircle: "chevron-left-circle",
  FeatherChevronLeftSquare: "chevron-left-square",
  FeatherChevronLeft: "chevron-left",
  FeatherChevronRightCircle: "chevron-right-circle",
  FeatherChevronRightSquare: "chevron-right-square",
  FeatherChevronRight: "chevron-right",
  FeatherChevronUpCircle: "chevron-up-circle",
  FeatherChevronUpSquare: "chevron-up-square",
  FeatherChevronUp: "chevron-up",
  FeatherChevronsDownUp: "chevrons-down-up",
  FeatherChevronsDown: "chevrons-down",
  FeatherChevronsLeftRightEllipsis: "chevrons-left-right-ellipsis",
  FeatherChevronsLeftRight: "chevrons-left-right",
  FeatherChevronsLeft: "chevrons-left",
  FeatherChevronsRightLeft: "chevrons-right-left",
  FeatherChevronsRight: "chevrons-right",
  FeatherChevronsUpDown: "chevrons-up-down",
  FeatherChevronsUp: "chevrons-up",
  FeatherChrome: "chrome",
  FeatherChurch: "church",
  FeatherCigaretteOff: "cigarette-off",
  FeatherCigarette: "cigarette",
  FeatherCircleArrowLeft: "circle-arrow-left",
  FeatherCircleArrowRight: "circle-arrow-right",
  FeatherCircleCheckBig: "circle-check-big",
  FeatherCircleCheck: "circle-check",
  FeatherCircleDashed: "circle-dashed",
  FeatherCircleDollarSign: "circle-dollar-sign",
  FeatherCircleDotDashed: "circle-dot-dashed",
  FeatherCircleDot: "circle-dot",
  FeatherCircleEllipsis: "circle-ellipsis",
  FeatherCircleEqual: "circle-equal",
  FeatherCircleFadingArrowUp: "circle-fading-arrow-up",
  FeatherCircleFadingPlus: "circle-fading-plus",
  FeatherCircleOff: "circle-off",
  FeatherCirclePoundSterling: "circle-pound-sterling",
  FeatherCirclePower: "circle-power",
  FeatherCircleSlash2: "circle-slash-2",
  FeatherCircleSlash: "circle-slash",
  FeatherCircleSlashed: "circle-slashed",
  FeatherCircleSmall: "circle-small",
  FeatherCircleStop: "circle-stop",
  FeatherCircle: "circle",
  FeatherCircuitBoard: "circuit-board",
  FeatherCitrus: "citrus",
  FeatherClapperboard: "clapperboard",
  FeatherClipboardCheck: "clipboard-check",
  FeatherClipboardCopy: "clipboard-copy",
  FeatherClipboardEdit: "clipboard-edit",
  FeatherClipboardList: "clipboard-list",
  FeatherClipboardMinus: "clipboard-minus",
  FeatherClipboardPaste: "clipboard-paste",
  FeatherClipboardPenLine: "clipboard-pen-line",
  FeatherClipboardPen: "clipboard-pen",
  FeatherClipboardPlus: "clipboard-plus",
  FeatherClipboardSignature: "clipboard-signature",
  FeatherClipboardType: "clipboard-type",
  FeatherClipboardX: "clipboard-x",
  FeatherClipboard: "clipboard",
  FeatherClock1: "clock-1",
  FeatherClock10: "clock-10",
  FeatherClock11: "clock-11",
  FeatherClock12: "clock-12",
  FeatherClock2: "clock-2",
  FeatherClock3: "clock-3",
  FeatherClock4: "clock-4",
  FeatherClock5: "clock-5",
  FeatherClock6: "clock-6",
  FeatherClock7: "clock-7",
  FeatherClock8: "clock-8",
  FeatherClock9: "clock-9",
  FeatherClockAlert: "clock-alert",
  FeatherClockArrowDown: "clock-arrow-down",
  FeatherClockArrowUp: "clock-arrow-up",
  FeatherClockFading: "clock-fading",
  FeatherClockPlus: "clock-plus",
  FeatherClock: "clock",
  FeatherCloudAlert: "cloud-alert",
  FeatherCloudCheck: "cloud-check",
  FeatherCloudCog: "cloud-cog",
  FeatherCloudDownload: "cloud-download",
  FeatherCloudDrizzle: "cloud-drizzle",
  FeatherCloudFog: "cloud-fog",
  FeatherCloudHail: "cloud-hail",
  FeatherCloudLightning: "cloud-lightning",
  FeatherCloudMoonRain: "cloud-moon-rain",
  FeatherCloudMoon: "cloud-moon",
  FeatherCloudOff: "cloud-off",
  FeatherCloudRainWind: "cloud-rain-wind",
  FeatherCloudRain: "cloud-rain",
  FeatherCloudSnow: "cloud-snow",
  FeatherCloudSunRain: "cloud-sun-rain",
  FeatherCloudSun: "cloud-sun",
  FeatherCloudUpload: "cloud-upload",
  FeatherCloud: "cloud",
  FeatherCloudy: "cloudy",
  FeatherClover: "clover",
  FeatherClub: "club",
  FeatherCode2: "code-2",
  FeatherCode: "code",
  FeatherCodepen: "codepen",
  FeatherCodesandbox: "codesandbox",
  FeatherCoffee: "coffee",
  FeatherCog: "cog",
  FeatherCoins: "coins",
  FeatherColumns2: "columns-2",
  FeatherColumns3Cog: "columns-3-cog",
  FeatherColumns3: "columns-3",
  FeatherColumns4: "columns-4",
  FeatherColumns: "columns",
  FeatherCombine: "combine",
  FeatherCommand: "command",
  FeatherCompass: "compass",
  FeatherComponent: "component",
  FeatherComputer: "computer",
  FeatherConciergeBell: "concierge-bell",
  FeatherCone: "cone",
  FeatherConstruction: "construction",
  FeatherContact2: "contact-2",
  FeatherContactRound: "contact-round",
  FeatherContact: "contact",
  FeatherContainer: "container",
  FeatherContrast: "contrast",
  FeatherCookie: "cookie",
  FeatherCookingPot: "cooking-pot",
  FeatherCopyCheck: "copy-check",
  FeatherCopyMinus: "copy-minus",
  FeatherCopyPlus: "copy-plus",
  FeatherCopySlash: "copy-slash",
  FeatherCopyX: "copy-x",
  FeatherCopy: "copy",
  FeatherCopyleft: "copyleft",
  FeatherCopyright: "copyright",
  FeatherCornerDownLeft: "corner-down-left",
  FeatherCornerDownRight: "corner-down-right",
  FeatherCornerFull: "corner-full",
  FeatherCornerLarge: "corner-large",
  FeatherCornerLeftDown: "corner-left-down",
  FeatherCornerLeftUp: "corner-left-up",
  FeatherCornerMedium: "corner-medium",
  FeatherCornerRightDown: "corner-right-down",
  FeatherCornerRightUp: "corner-right-up",
  FeatherCornerSmall: "corner-small",
  FeatherCornerUpLeft: "corner-up-left",
  FeatherCornerUpRight: "corner-up-right",
  FeatherCpu: "cpu",
  FeatherCreativeCommons: "creative-commons",
  FeatherCreditCard: "credit-card",
  FeatherCroissant: "croissant",
  FeatherCrop: "crop",
  FeatherCross: "cross",
  FeatherCrosshair: "crosshair",
  FeatherCrown: "crown",
  FeatherCuboid: "cuboid",
  FeatherCupSoda: "cup-soda",
  FeatherCurlyBraces: "curly-braces",
  FeatherCurrency: "currency",
  FeatherCylinder: "cylinder",
  FeatherDam: "dam",
  FeatherDatabaseBackup: "database-backup",
  FeatherDatabaseZap: "database-zap",
  FeatherDatabase: "database",
  FeatherDecimalsArrowLeft: "decimals-arrow-left",
  FeatherDecimalsArrowRight: "decimals-arrow-right",
  FeatherDelete: "delete",
  FeatherDessert: "dessert",
  FeatherDiameter: "diameter",
  FeatherDiamondMinus: "diamond-minus",
  FeatherDiamondPlus: "diamond-plus",
  FeatherDiamond: "diamond",
  FeatherDice1: "dice-1",
  FeatherDice2: "dice-2",
  FeatherDice3: "dice-3",
  FeatherDice4: "dice-4",
  FeatherDice5: "dice-5",
  FeatherDice6: "dice-6",
  FeatherDices: "dices",
  FeatherDiff: "diff",
  FeatherDisc2: "disc-2",
  FeatherDisc3: "disc-3",
  FeatherDiscAlbum: "disc-album",
  FeatherDisc: "disc",
  FeatherDivideCircle: "divide-circle",
  FeatherDivideSquare: "divide-square",
  FeatherDivide: "divide",
  FeatherDnaOff: "dna-off",
  FeatherDna: "dna",
  FeatherDock: "dock",
  FeatherDog: "dog",
  FeatherDollarSign: "dollar-sign",
  FeatherDonut: "donut",
  FeatherDoorClosedLocked: "door-closed-locked",
  FeatherDoorClosed: "door-closed",
  FeatherDoorOpen: "door-open",
  FeatherDot: "dot",
  FeatherDownloadCloud: "download-cloud",
  FeatherDownload: "download",
  FeatherDraftingCompass: "drafting-compass",
  FeatherDrama: "drama",
  FeatherDribbble: "dribbble",
  FeatherDrill: "drill",
  FeatherDrone: "drone",
  FeatherDropletOff: "droplet-off",
  FeatherDroplet: "droplet",
  FeatherDroplets: "droplets",
  FeatherDrum: "drum",
  FeatherDrumstick: "drumstick",
  FeatherDumbbell: "dumbbell",
  FeatherEarOff: "ear-off",
  FeatherEar: "ear",
  FeatherEarthLock: "earth-lock",
  FeatherEarth: "earth",
  FeatherEclipse: "eclipse",
  FeatherEdit2: "edit-2",
  FeatherEdit3: "edit-3",
  FeatherEdit: "edit",
  FeatherEggFried: "egg-fried",
  FeatherEggOff: "egg-off",
  FeatherEgg: "egg",
  FeatherEqualApproximately: "equal-approximately",
  FeatherEqualNot: "equal-not",
  FeatherEqual: "equal",
  FeatherEraser: "eraser",
  FeatherEthernetPort: "ethernet-port",
  FeatherEuro: "euro",
  FeatherExpand: "expand",
  FeatherExternalLink: "external-link",
  FeatherEyeClosed: "eye-closed",
  FeatherEyeOff: "eye-off",
  FeatherEye: "eye",
  FeatherFacebook: "facebook",
  FeatherFactory: "factory",
  FeatherFan: "fan",
  FeatherFastForward: "fast-forward",
  FeatherFeather: "feather",
  FeatherFence: "fence",
  FeatherFerrisWheel: "ferris-wheel",
  FeatherFigma: "figma",
  FeatherFileArchive: "file-archive",
  FeatherFileAudio2: "file-audio-2",
  FeatherFileAudio: "file-audio",
  FeatherFileAxis3D: "file-axis-3d",
  FeatherFileBadge2: "file-badge-2",
  FeatherFileBadge: "file-badge",
  FeatherFileBarChart2: "file-bar-chart-2",
  FeatherFileBarChart: "file-bar-chart",
  FeatherFileBox: "file-box",
  FeatherFileChartColumnIncreasing: "file-chart-column-increasing",
  FeatherFileChartColumn: "file-chart-column",
  FeatherFileChartLine: "file-chart-line",
  FeatherFileChartPie: "file-chart-pie",
  FeatherFileCheck2: "file-check-2",
  FeatherFileCheck: "file-check",
  FeatherFileClock: "file-clock",
  FeatherFileCode2: "file-code-2",
  FeatherFileCode: "file-code",
  FeatherFileCog2: "file-cog-2",
  FeatherFileCog: "file-cog",
  FeatherFileDiff: "file-diff",
  FeatherFileDigit: "file-digit",
  FeatherFileDown: "file-down",
  FeatherFileEdit: "file-edit",
  FeatherFileHeart: "file-heart",
  FeatherFileImage: "file-image",
  FeatherFileInput: "file-input",
  FeatherFileJson2: "file-json-2",
  FeatherFileJson: "file-json",
  FeatherFileKey2: "file-key-2",
  FeatherFileKey: "file-key",
  FeatherFileLineChart: "file-line-chart",
  FeatherFileLock2: "file-lock-2",
  FeatherFileLock: "file-lock",
  FeatherFileMinus2: "file-minus-2",
  FeatherFileMinus: "file-minus",
  FeatherFileMusic: "file-music",
  FeatherFileOutput: "file-output",
  FeatherFilePenLine: "file-pen-line",
  FeatherFilePen: "file-pen",
  FeatherFilePieChart: "file-pie-chart",
  FeatherFilePlus2: "file-plus-2",
  FeatherFilePlus: "file-plus",
  FeatherFileQuestionMark: "file-question-mark",
  FeatherFileQuestion: "file-question",
  FeatherFileScan: "file-scan",
  FeatherFileSearch2: "file-search-2",
  FeatherFileSearch: "file-search",
  FeatherFileSignature: "file-signature",
  FeatherFileSliders: "file-sliders",
  FeatherFileSpreadsheet: "file-spreadsheet",
  FeatherFileStack: "file-stack",
  FeatherFileSymlink: "file-symlink",
  FeatherFileTerminal: "file-terminal",
  FeatherFileText: "file-text",
  FeatherFileType2: "file-type-2",
  FeatherFileType: "file-type",
  FeatherFileUp: "file-up",
  FeatherFileUser: "file-user",
  FeatherFileVideo2: "file-video-2",
  FeatherFileVideo: "file-video",
  FeatherFileVolume2: "file-volume-2",
  FeatherFileVolume: "file-volume",
  FeatherFileWarning: "file-warning",
  FeatherFileX2: "file-x-2",
  FeatherFileX: "file-x",
  FeatherFile: "file",
  FeatherFiles: "files",
  FeatherFilm: "film",
  FeatherFilterX: "filter-x",
  FeatherFilter: "filter",
  FeatherFingerprint: "fingerprint",
  FeatherFireExtinguisher: "fire-extinguisher",
  FeatherFishOff: "fish-off",
  FeatherFishSymbol: "fish-symbol",
  FeatherFish: "fish",
  FeatherFlagOff: "flag-off",
  FeatherFlagTriangleLeft: "flag-triangle-left",
  FeatherFlagTriangleRight: "flag-triangle-right",
  FeatherFlag: "flag",
  FeatherFlameKindling: "flame-kindling",
  FeatherFlame: "flame",
  FeatherFlashlightOff: "flashlight-off",
  FeatherFlashlight: "flashlight",
  FeatherFlaskConicalOff: "flask-conical-off",
  FeatherFlaskConical: "flask-conical",
  FeatherFlaskRound: "flask-round",
  FeatherFlipHorizontal2: "flip-horizontal-2",
  FeatherFlipHorizontal: "flip-horizontal",
  FeatherFlipVertical2: "flip-vertical-2",
  FeatherFlipVertical: "flip-vertical",
  FeatherFlower2: "flower-2",
  FeatherFlower: "flower",
  FeatherFocus: "focus",
  FeatherFoldHorizontal: "fold-horizontal",
  FeatherFoldVertical: "fold-vertical",
  FeatherFolderArchive: "folder-archive",
  FeatherFolderCheck: "folder-check",
  FeatherFolderClock: "folder-clock",
  FeatherFolderClosed: "folder-closed",
  FeatherFolderCode: "folder-code",
  FeatherFolderCog2: "folder-cog-2",
  FeatherFolderCog: "folder-cog",
  FeatherFolderDot: "folder-dot",
  FeatherFolderDown: "folder-down",
  FeatherFolderEdit: "folder-edit",
  FeatherFolderGit2: "folder-git-2",
  FeatherFolderGit: "folder-git",
  FeatherFolderHeart: "folder-heart",
  FeatherFolderInput: "folder-input",
  FeatherFolderKanban: "folder-kanban",
  FeatherFolderKey: "folder-key",
  FeatherFolderLock: "folder-lock",
  FeatherFolderMinus: "folder-minus",
  FeatherFolderOpenDot: "folder-open-dot",
  FeatherFolderOpen: "folder-open",
  FeatherFolderOutput: "folder-output",
  FeatherFolderPen: "folder-pen",
  FeatherFolderPlus: "folder-plus",
  FeatherFolderRoot: "folder-root",
  FeatherFolderSearch2: "folder-search-2",
  FeatherFolderSearch: "folder-search",
  FeatherFolderSymlink: "folder-symlink",
  FeatherFolderSync: "folder-sync",
  FeatherFolderTree: "folder-tree",
  FeatherFolderUp: "folder-up",
  FeatherFolderX: "folder-x",
  FeatherFolder: "folder",
  FeatherFolders: "folders",
  FeatherFootprints: "footprints",
  FeatherForklift: "forklift",
  FeatherFormInput: "form-input",
  FeatherForward: "forward",
  FeatherFrame: "frame",
  FeatherFramer: "framer",
  FeatherFrown: "frown",
  FeatherFuel: "fuel",
  FeatherFullscreen: "fullscreen",
  FeatherFunctionSquare: "function-square",
  FeatherFunnelPlus: "funnel-plus",
  FeatherFunnelX: "funnel-x",
  FeatherFunnel: "funnel",
  FeatherGalleryHorizontalEnd: "gallery-horizontal-end",
  FeatherGalleryHorizontal: "gallery-horizontal",
  FeatherGalleryThumbnails: "gallery-thumbnails",
  FeatherGalleryVerticalEnd: "gallery-vertical-end",
  FeatherGalleryVertical: "gallery-vertical",
  FeatherGamepad2: "gamepad-2",
  FeatherGamepad: "gamepad",
  FeatherGanttChartSquare: "gantt-chart-square",
  FeatherGanttChart: "gantt-chart",
  FeatherGaugeCircle: "gauge-circle",
  FeatherGauge: "gauge",
  FeatherGavel: "gavel",
  FeatherGem: "gem",
  FeatherGeorgianLari: "georgian-lari",
  FeatherGhost: "ghost",
  FeatherGift: "gift",
  FeatherGitBranchPlus: "git-branch-plus",
  FeatherGitBranch: "git-branch",
  FeatherGitCommitHorizontal: "git-commit-horizontal",
  FeatherGitCommitVertical: "git-commit-vertical",
  FeatherGitCommit: "git-commit",
  FeatherGitCompareArrows: "git-compare-arrows",
  FeatherGitCompare: "git-compare",
  FeatherGitFork: "git-fork",
  FeatherGitGraph: "git-graph",
  FeatherGitMerge: "git-merge",
  FeatherGitPullRequestArrow: "git-pull-request-arrow",
  FeatherGitPullRequestClosed: "git-pull-request-closed",
  FeatherGitPullRequestCreateArrow: "git-pull-request-create-arrow",
  FeatherGitPullRequestCreate: "git-pull-request-create",
  FeatherGitPullRequestDraft: "git-pull-request-draft",
  FeatherGitPullRequest: "git-pull-request",
  FeatherGithub: "github",
  FeatherGitlab: "gitlab",
  FeatherGlassWater: "glass-water",
  FeatherGlasses: "glasses",
  FeatherGlobe2: "globe-2",
  FeatherGlobeLock: "globe-lock",
  FeatherGlobe: "globe",
  FeatherGoal: "goal",
  FeatherGpu: "gpu",
  FeatherGrab: "grab",
  FeatherGraduationCap: "graduation-cap",
  FeatherGrape: "grape",
  FeatherGrid2X2Check: "grid-2x2-check",
  FeatherGrid2X2Plus: "grid-2x2-plus",
  FeatherGrid2X2X: "grid-2x2-x",
  FeatherGrid2X2: "grid-2x2",
  FeatherGrid3X2: "grid-3x2",
  FeatherGrid3X3: "grid-3x3",
  FeatherGrid: "grid",
  FeatherGripHorizontal: "grip-horizontal",
  FeatherGripVertical: "grip-vertical",
  FeatherGrip: "grip",
  FeatherGroup: "group",
  FeatherGuitar: "guitar",
  FeatherHam: "ham",
  FeatherHamburger: "hamburger",
  FeatherHammer: "hammer",
  FeatherHandCoins: "hand-coins",
  FeatherHandHeart: "hand-heart",
  FeatherHandHelping: "hand-helping",
  FeatherHandMetal: "hand-metal",
  FeatherHandPlatter: "hand-platter",
  FeatherHand: "hand",
  FeatherHandshake: "handshake",
  FeatherHardDriveDownload: "hard-drive-download",
  FeatherHardDriveUpload: "hard-drive-upload",
  FeatherHardDrive: "hard-drive",
  FeatherHardHat: "hard-hat",
  FeatherHash: "hash",
  FeatherHaze: "haze",
  FeatherHdmiPort: "hdmi-port",
  FeatherHeading1: "heading-1",
  FeatherHeading2: "heading-2",
  FeatherHeading3: "heading-3",
  FeatherHeading4: "heading-4",
  FeatherHeading5: "heading-5",
  FeatherHeading6: "heading-6",
  FeatherHeading: "heading",
  FeatherHeadphoneOff: "headphone-off",
  FeatherHeadphones: "headphones",
  FeatherHeadset: "headset",
  FeatherHeartCrack: "heart-crack",
  FeatherHeartHandshake: "heart-handshake",
  FeatherHeartMinus: "heart-minus",
  FeatherHeartOff: "heart-off",
  FeatherHeartPlus: "heart-plus",
  FeatherHeartPulse: "heart-pulse",
  FeatherHeart: "heart",
  FeatherHeater: "heater",
  FeatherHelpCircle: "help-circle",
  FeatherHelpingHand: "helping-hand",
  FeatherHexagon: "hexagon",
  FeatherHighlighter: "highlighter",
  FeatherHistory: "history",
  FeatherHome: "home",
  FeatherHopOff: "hop-off",
  FeatherHop: "hop",
  FeatherHospital: "hospital",
  FeatherHotel: "hotel",
  FeatherHourglass: "hourglass",
  FeatherHousePlug: "house-plug",
  FeatherHousePlus: "house-plus",
  FeatherHouseWifi: "house-wifi",
  FeatherHouse: "house",
  FeatherIceCream2: "ice-cream-2",
  FeatherIceCreamBowl: "ice-cream-bowl",
  FeatherIceCream: "ice-cream",
  FeatherIdCardLanyard: "id-card-lanyard",
  FeatherIdCard: "id-card",
  FeatherImageDown: "image-down",
  FeatherImageMinus: "image-minus",
  FeatherImageOff: "image-off",
  FeatherImagePlay: "image-play",
  FeatherImagePlus: "image-plus",
  FeatherImageUp: "image-up",
  FeatherImageUpscale: "image-upscale",
  FeatherImage: "image",
  FeatherImages: "images",
  FeatherImport: "import",
  FeatherInbox: "inbox",
  FeatherIndentDecrease: "indent-decrease",
  FeatherIndentIncrease: "indent-increase",
  FeatherIndent: "indent",
  FeatherIndianRupee: "indian-rupee",
  FeatherInfinity: "infinity",
  FeatherInfo: "info",
  FeatherInspect: "inspect",
  FeatherInspectionPanel: "inspection-panel",
  FeatherInstagram: "instagram",
  FeatherItalic: "italic",
  FeatherIterationCcw: "iteration-ccw",
  FeatherIterationCw: "iteration-cw",
  FeatherJapaneseYen: "japanese-yen",
  FeatherJoystick: "joystick",
  FeatherKanbanSquareDashed: "kanban-square-dashed",
  FeatherKanbanSquare: "kanban-square",
  FeatherKanban: "kanban",
  FeatherKeyRound: "key-round",
  FeatherKeySquare: "key-square",
  FeatherKey: "key",
  FeatherKeyboardMusic: "keyboard-music",
  FeatherKeyboardOff: "keyboard-off",
  FeatherKeyboard: "keyboard",
  FeatherLampCeiling: "lamp-ceiling",
  FeatherLampDesk: "lamp-desk",
  FeatherLampFloor: "lamp-floor",
  FeatherLampWallDown: "lamp-wall-down",
  FeatherLampWallUp: "lamp-wall-up",
  FeatherLamp: "lamp",
  FeatherLandPlot: "land-plot",
  FeatherLandmark: "landmark",
  FeatherLanguages: "languages",
  FeatherLaptop2: "laptop-2",
  FeatherLaptopMinimalCheck: "laptop-minimal-check",
  FeatherLaptop: "laptop",
  FeatherLassoSelect: "lasso-select",
  FeatherLasso: "lasso",
  FeatherLaugh: "laugh",
  FeatherLayers2: "layers-2",
  FeatherLayers3: "layers-3",
  FeatherLayers: "layers",
  FeatherLayoutDashboard: "layout-dashboard",
  FeatherLayoutGrid: "layout-grid",
  FeatherLayoutList: "layout-list",
  FeatherLayoutPanelLeft: "layout-panel-left",
  FeatherLayoutPanelTop: "layout-panel-top",
  FeatherLayoutTemplate: "layout-template",
  FeatherLayout: "layout",
  FeatherLeaf: "leaf",
  FeatherLeafyGreen: "leafy-green",
  FeatherLectern: "lectern",
  FeatherLetterSpacing: "letter-spacing",
  FeatherLetterText: "letter-text",
  FeatherLibraryBig: "library-big",
  FeatherLibrarySquare: "library-square",
  FeatherLibrary: "library",
  FeatherLifeBuoy: "life-buoy",
  FeatherLigature: "ligature",
  FeatherLightbulbOff: "lightbulb-off",
  FeatherLightbulb: "lightbulb",
  FeatherLineChart: "line-chart",
  FeatherLineHeight: "line-height",
  FeatherLineSquiggle: "line-squiggle",
  FeatherLink2Off: "link-2-off",
  FeatherLink2: "link-2",
  FeatherLink: "link",
  FeatherLinkedin: "linkedin",
  FeatherListCheck: "list-check",
  FeatherListChecks: "list-checks",
  FeatherListCollapse: "list-collapse",
  FeatherListEnd: "list-end",
  FeatherListFilterPlus: "list-filter-plus",
  FeatherListFilter: "list-filter",
  FeatherListMinus: "list-minus",
  FeatherListMusic: "list-music",
  FeatherListOrdered: "list-ordered",
  FeatherListPlus: "list-plus",
  FeatherListRestart: "list-restart",
  FeatherListStart: "list-start",
  FeatherListTodo: "list-todo",
  FeatherListTree: "list-tree",
  FeatherListVideo: "list-video",
  FeatherListX: "list-x",
  FeatherList: "list",
  FeatherLoader2: "loader-2",
  FeatherLoaderPinwheel: "loader-pinwheel",
  FeatherLoader: "loader",
  FeatherLocateFixed: "locate-fixed",
  FeatherLocateOff: "locate-off",
  FeatherLocate: "locate",
  FeatherLocationEdit: "location-edit",
  FeatherLockKeyholeOpen: "lock-keyhole-open",
  FeatherLockKeyhole: "lock-keyhole",
  FeatherLock: "lock",
  FeatherLogIn: "log-in",
  FeatherLogOut: "log-out",
  FeatherLogs: "logs",
  FeatherLollipop: "lollipop",
  FeatherLuggage: "luggage",
  FeatherMSquare: "m-square",
  FeatherMagnet: "magnet",
  FeatherMailCheck: "mail-check",
  FeatherMailMinus: "mail-minus",
  FeatherMailOpen: "mail-open",
  FeatherMailPlus: "mail-plus",
  FeatherMailQuestion: "mail-question",
  FeatherMailSearch: "mail-search",
  FeatherMailWarning: "mail-warning",
  FeatherMailX: "mail-x",
  FeatherMail: "mail",
  FeatherMailbox: "mailbox",
  FeatherMails: "mails",
  FeatherMapPinCheckInside: "map-pin-check-inside",
  FeatherMapPinCheck: "map-pin-check",
  FeatherMapPinHouse: "map-pin-house",
  FeatherMapPinMinusInside: "map-pin-minus-inside",
  FeatherMapPinMinus: "map-pin-minus",
  FeatherMapPinOff: "map-pin-off",
  FeatherMapPinPlusInside: "map-pin-plus-inside",
  FeatherMapPinPlus: "map-pin-plus",
  FeatherMapPinXInside: "map-pin-x-inside",
  FeatherMapPinX: "map-pin-x",
  FeatherMapPin: "map-pin",
  FeatherMapPinned: "map-pinned",
  FeatherMapPlus: "map-plus",
  FeatherMap: "map",
  FeatherMarsStroke: "mars-stroke",
  FeatherMars: "mars",
  FeatherMartini: "martini",
  FeatherMaximize2: "maximize-2",
  FeatherMaximize: "maximize",
  FeatherMedal: "medal",
  FeatherMegaphoneOff: "megaphone-off",
  FeatherMegaphone: "megaphone",
  FeatherMeh: "meh",
  FeatherMemoryStick: "memory-stick",
  FeatherMenuSquare: "menu-square",
  FeatherMenu: "menu",
  FeatherMerge: "merge",
  FeatherMessageCircleCode: "message-circle-code",
  FeatherMessageCircleDashed: "message-circle-dashed",
  FeatherMessageCircleHeart: "message-circle-heart",
  FeatherMessageCircleMore: "message-circle-more",
  FeatherMessageCircleOff: "message-circle-off",
  FeatherMessageCirclePlus: "message-circle-plus",
  FeatherMessageCircleQuestionMark: "message-circle-question-mark",
  FeatherMessageCircleReply: "message-circle-reply",
  FeatherMessageCircleWarning: "message-circle-warning",
  FeatherMessageCircleX: "message-circle-x",
  FeatherMessageCircle: "message-circle",
  FeatherMessageSquareCode: "message-square-code",
  FeatherMessageSquareDashed: "message-square-dashed",
  FeatherMessageSquareDiff: "message-square-diff",
  FeatherMessageSquareDot: "message-square-dot",
  FeatherMessageSquareHeart: "message-square-heart",
  FeatherMessageSquareLock: "message-square-lock",
  FeatherMessageSquareMore: "message-square-more",
  FeatherMessageSquareOff: "message-square-off",
  FeatherMessageSquarePlus: "message-square-plus",
  FeatherMessageSquareQuote: "message-square-quote",
  FeatherMessageSquareReply: "message-square-reply",
  FeatherMessageSquareShare: "message-square-share",
  FeatherMessageSquareText: "message-square-text",
  FeatherMessageSquareWarning: "message-square-warning",
  FeatherMessageSquareX: "message-square-x",
  FeatherMessageSquare: "message-square",
  FeatherMessagesSquare: "messages-square",
  FeatherMic2: "mic-2",
  FeatherMicOff: "mic-off",
  FeatherMicVocal: "mic-vocal",
  FeatherMic: "mic",
  FeatherMicrochip: "microchip",
  FeatherMicroscope: "microscope",
  FeatherMicrowave: "microwave",
  FeatherMilestone: "milestone",
  FeatherMilkOff: "milk-off",
  FeatherMilk: "milk",
  FeatherMinimize2: "minimize-2",
  FeatherMinimize: "minimize",
  FeatherMinusCircle: "minus-circle",
  FeatherMinusSquare: "minus-square",
  FeatherMinus: "minus",
  FeatherMonitorCheck: "monitor-check",
  FeatherMonitorCog: "monitor-cog",
  FeatherMonitorDot: "monitor-dot",
  FeatherMonitorDown: "monitor-down",
  FeatherMonitorOff: "monitor-off",
  FeatherMonitorPause: "monitor-pause",
  FeatherMonitorPlay: "monitor-play",
  FeatherMonitorSmartphone: "monitor-smartphone",
  FeatherMonitorSpeaker: "monitor-speaker",
  FeatherMonitorStop: "monitor-stop",
  FeatherMonitorUp: "monitor-up",
  FeatherMonitorX: "monitor-x",
  FeatherMonitor: "monitor",
  FeatherMoonStar: "moon-star",
  FeatherMoon: "moon",
  FeatherMoreHorizontal: "more-horizontal",
  FeatherMoreVertical: "more-vertical",
  FeatherMountainSnow: "mountain-snow",
  FeatherMountain: "mountain",
  FeatherMouseOff: "mouse-off",
  FeatherMousePointer2: "mouse-pointer-2",
  FeatherMousePointerBan: "mouse-pointer-ban",
  FeatherMousePointerClick: "mouse-pointer-click",
  FeatherMousePointerSquareDashed: "mouse-pointer-square-dashed",
  FeatherMousePointerSquare: "mouse-pointer-square",
  FeatherMousePointer: "mouse-pointer",
  FeatherMouse: "mouse",
  FeatherMove3D: "move-3d",
  FeatherMoveDiagonal2: "move-diagonal-2",
  FeatherMoveDiagonal: "move-diagonal",
  FeatherMoveDownLeft: "move-down-left",
  FeatherMoveDownRight: "move-down-right",
  FeatherMoveDown: "move-down",
  FeatherMoveHorizontal: "move-horizontal",
  FeatherMoveLeft: "move-left",
  FeatherMoveRight: "move-right",
  FeatherMoveUpLeft: "move-up-left",
  FeatherMoveUpRight: "move-up-right",
  FeatherMoveUp: "move-up",
  FeatherMoveVertical: "move-vertical",
  FeatherMove: "move",
  FeatherMusic2: "music-2",
  FeatherMusic3: "music-3",
  FeatherMusic4: "music-4",
  FeatherMusic: "music",
  FeatherNavigation2Off: "navigation-2-off",
  FeatherNavigation2: "navigation-2",
  FeatherNavigationOff: "navigation-off",
  FeatherNavigation: "navigation",
  FeatherNetwork: "network",
  FeatherNewspaper: "newspaper",
  FeatherNfc: "nfc",
  FeatherNonBinary: "non-binary",
  FeatherNotebookPen: "notebook-pen",
  FeatherNotebookTabs: "notebook-tabs",
  FeatherNotebookText: "notebook-text",
  FeatherNotebook: "notebook",
  FeatherNotepadTextDashed: "notepad-text-dashed",
  FeatherNotepadText: "notepad-text",
  FeatherNutOff: "nut-off",
  FeatherNut: "nut",
  FeatherOctagonAlert: "octagon-alert",
  FeatherOctagonMinus: "octagon-minus",
  FeatherOctagonPause: "octagon-pause",
  FeatherOctagonX: "octagon-x",
  FeatherOctagon: "octagon",
  FeatherOmega: "omega",
  FeatherOption: "option",
  FeatherOrbit: "orbit",
  FeatherOrigami: "origami",
  FeatherOutdent: "outdent",
  FeatherPackage2: "package-2",
  FeatherPackageCheck: "package-check",
  FeatherPackageMinus: "package-minus",
  FeatherPackageOpen: "package-open",
  FeatherPackagePlus: "package-plus",
  FeatherPackageSearch: "package-search",
  FeatherPackageX: "package-x",
  FeatherPackage: "package",
  FeatherPaintBucket: "paint-bucket",
  FeatherPaintRoller: "paint-roller",
  FeatherPaintbrush2: "paintbrush-2",
  FeatherPaintbrushVertical: "paintbrush-vertical",
  FeatherPaintbrush: "paintbrush",
  FeatherPalette: "palette",
  FeatherPalmtree: "palmtree",
  FeatherPanda: "panda",
  FeatherPanelBottomClose: "panel-bottom-close",
  FeatherPanelBottomInactive: "panel-bottom-inactive",
  FeatherPanelBottomOpen: "panel-bottom-open",
  FeatherPanelBottom: "panel-bottom",
  FeatherPanelLeftClose: "panel-left-close",
  FeatherPanelLeftInactive: "panel-left-inactive",
  FeatherPanelLeftOpen: "panel-left-open",
  FeatherPanelLeft: "panel-left",
  FeatherPanelRightClose: "panel-right-close",
  FeatherPanelRightInactive: "panel-right-inactive",
  FeatherPanelRightOpen: "panel-right-open",
  FeatherPanelRight: "panel-right",
  FeatherPanelTopClose: "panel-top-close",
  FeatherPanelTopInactive: "panel-top-inactive",
  FeatherPanelTopOpen: "panel-top-open",
  FeatherPanelTop: "panel-top",
  FeatherPanelsLeftBottom: "panels-left-bottom",
  FeatherPanelsRightBottom: "panels-right-bottom",
  FeatherPanelsTopLeft: "panels-top-left",
  FeatherPaperclip: "paperclip",
  FeatherParentheses: "parentheses",
  FeatherParkingCircleOff: "parking-circle-off",
  FeatherParkingCircle: "parking-circle",
  FeatherParkingMeter: "parking-meter",
  FeatherParkingSquareOff: "parking-square-off",
  FeatherParkingSquare: "parking-square",
  FeatherPartyPopper: "party-popper",
  FeatherPauseCircle: "pause-circle",
  FeatherPauseOctagon: "pause-octagon",
  FeatherPause: "pause",
  FeatherPawPrint: "paw-print",
  FeatherPcCase: "pc-case",
  FeatherPenLine: "pen-line",
  FeatherPenOff: "pen-off",
  FeatherPenSquare: "pen-square",
  FeatherPenTool: "pen-tool",
  FeatherPen: "pen",
  FeatherPencilLine: "pencil-line",
  FeatherPencilOff: "pencil-off",
  FeatherPencilRuler: "pencil-ruler",
  FeatherPencil: "pencil",
  FeatherPentagon: "pentagon",
  FeatherPercentCircle: "percent-circle",
  FeatherPercentDiamond: "percent-diamond",
  FeatherPercentSquare: "percent-square",
  FeatherPercent: "percent",
  FeatherPersonStanding: "person-standing",
  FeatherPhilippinePeso: "philippine-peso",
  FeatherPhoneCall: "phone-call",
  FeatherPhoneForwarded: "phone-forwarded",
  FeatherPhoneIncoming: "phone-incoming",
  FeatherPhoneMissed: "phone-missed",
  FeatherPhoneOff: "phone-off",
  FeatherPhoneOutgoing: "phone-outgoing",
  FeatherPhone: "phone",
  FeatherPiSquare: "pi-square",
  FeatherPi: "pi",
  FeatherPiano: "piano",
  FeatherPickaxe: "pickaxe",
  FeatherPictureInPicture2: "picture-in-picture-2",
  FeatherPictureInPicture: "picture-in-picture",
  FeatherPieChart: "pie-chart",
  FeatherPiggyBank: "piggy-bank",
  FeatherPilcrowLeft: "pilcrow-left",
  FeatherPilcrowRight: "pilcrow-right",
  FeatherPilcrowSquare: "pilcrow-square",
  FeatherPilcrow: "pilcrow",
  FeatherPillBottle: "pill-bottle",
  FeatherPill: "pill",
  FeatherPinOff: "pin-off",
  FeatherPin: "pin",
  FeatherPipette: "pipette",
  FeatherPizza: "pizza",
  FeatherPlaneLanding: "plane-landing",
  FeatherPlaneTakeoff: "plane-takeoff",
  FeatherPlane: "plane",
  FeatherPlayCircle: "play-circle",
  FeatherPlaySquare: "play-square",
  FeatherPlay: "play",
  FeatherPlug2: "plug-2",
  FeatherPlugZap2: "plug-zap-2",
  FeatherPlugZap: "plug-zap",
  FeatherPlug: "plug",
  FeatherPlusCircle: "plus-circle",
  FeatherPlusSquare: "plus-square",
  FeatherPlus: "plus",
  FeatherPocketKnife: "pocket-knife",
  FeatherPocket: "pocket",
  FeatherPodcast: "podcast",
  FeatherPointerOff: "pointer-off",
  FeatherPointer: "pointer",
  FeatherPopcorn: "popcorn",
  FeatherPopsicle: "popsicle",
  FeatherPoundSterling: "pound-sterling",
  FeatherPowerCircle: "power-circle",
  FeatherPowerOff: "power-off",
  FeatherPowerSquare: "power-square",
  FeatherPower: "power",
  FeatherPresentation: "presentation",
  FeatherPrinterCheck: "printer-check",
  FeatherPrinter: "printer",
  FeatherProjector: "projector",
  FeatherProportions: "proportions",
  FeatherPuzzle: "puzzle",
  FeatherPyramid: "pyramid",
  FeatherQrCode: "qr-code",
  FeatherQuote: "quote",
  FeatherRabbit: "rabbit",
  FeatherRadar: "radar",
  FeatherRadiation: "radiation",
  FeatherRadical: "radical",
  FeatherRadioReceiver: "radio-receiver",
  FeatherRadioTower: "radio-tower",
  FeatherRadio: "radio",
  FeatherRadius: "radius",
  FeatherRailSymbol: "rail-symbol",
  FeatherRainbow: "rainbow",
  FeatherRat: "rat",
  FeatherRatio: "ratio",
  FeatherReceiptCent: "receipt-cent",
  FeatherReceiptEuro: "receipt-euro",
  FeatherReceiptIndianRupee: "receipt-indian-rupee",
  FeatherReceiptJapaneseYen: "receipt-japanese-yen",
  FeatherReceiptPoundSterling: "receipt-pound-sterling",
  FeatherReceiptRussianRuble: "receipt-russian-ruble",
  FeatherReceiptSwissFranc: "receipt-swiss-franc",
  FeatherReceiptText: "receipt-text",
  FeatherReceipt: "receipt",
  FeatherRectangleCircle: "rectangle-circle",
  FeatherRectangleGoggles: "rectangle-goggles",
  FeatherRectangleHorizontal: "rectangle-horizontal",
  FeatherRectangleVertical: "rectangle-vertical",
  FeatherRecycle: "recycle",
  FeatherRedo2: "redo-2",
  FeatherRedoDot: "redo-dot",
  FeatherRedo: "redo",
  FeatherRefreshCcwDot: "refresh-ccw-dot",
  FeatherRefreshCcw: "refresh-ccw",
  FeatherRefreshCwOff: "refresh-cw-off",
  FeatherRefreshCw: "refresh-cw",
  FeatherRefrigerator: "refrigerator",
  FeatherRegex: "regex",
  FeatherRemoveFormatting: "remove-formatting",
  FeatherRepeat1: "repeat-1",
  FeatherRepeat2: "repeat-2",
  FeatherRepeat: "repeat",
  FeatherReplaceAll: "replace-all",
  FeatherReplace: "replace",
  FeatherReplyAll: "reply-all",
  FeatherReply: "reply",
  FeatherRewind: "rewind",
  FeatherRibbon: "ribbon",
  FeatherRocket: "rocket",
  FeatherRockingChair: "rocking-chair",
  FeatherRollerCoaster: "roller-coaster",
  FeatherRotate3D: "rotate-3d",
  FeatherRotateCcwKey: "rotate-ccw-key",
  FeatherRotateCcwSquare: "rotate-ccw-square",
  FeatherRotateCcw: "rotate-ccw",
  FeatherRotateCwSquare: "rotate-cw-square",
  FeatherRotateCw: "rotate-cw",
  FeatherRouteOff: "route-off",
  FeatherRoute: "route",
  FeatherRouter: "router",
  FeatherRows2: "rows-2",
  FeatherRows3: "rows-3",
  FeatherRows4: "rows-4",
  FeatherRows: "rows",
  FeatherRss: "rss",
  FeatherRulerDimensionLine: "ruler-dimension-line",
  FeatherRuler: "ruler",
  FeatherRussianRuble: "russian-ruble",
  FeatherSailboat: "sailboat",
  FeatherSalad: "salad",
  FeatherSandwich: "sandwich",
  FeatherSatelliteDish: "satellite-dish",
  FeatherSatellite: "satellite",
  FeatherSaudiRiyal: "saudi-riyal",
  FeatherSaveAll: "save-all",
  FeatherSaveOff: "save-off",
  FeatherSave: "save",
  FeatherScale3D: "scale-3d",
  FeatherScale: "scale",
  FeatherScaling: "scaling",
  FeatherScanBarcode: "scan-barcode",
  FeatherScanEye: "scan-eye",
  FeatherScanFace: "scan-face",
  FeatherScanHeart: "scan-heart",
  FeatherScanLine: "scan-line",
  FeatherScanQrCode: "scan-qr-code",
  FeatherScanSearch: "scan-search",
  FeatherScanText: "scan-text",
  FeatherScan: "scan",
  FeatherScatterChart: "scatter-chart",
  FeatherSchool2: "school-2",
  FeatherSchool: "school",
  FeatherScissorsLineDashed: "scissors-line-dashed",
  FeatherScissorsSquareDashedBottom: "scissors-square-dashed-bottom",
  FeatherScissorsSquare: "scissors-square",
  FeatherScissors: "scissors",
  FeatherScreenShareOff: "screen-share-off",
  FeatherScreenShare: "screen-share",
  FeatherScrollText: "scroll-text",
  FeatherScroll: "scroll",
  FeatherSearchCheck: "search-check",
  FeatherSearchCode: "search-code",
  FeatherSearchSlash: "search-slash",
  FeatherSearchX: "search-x",
  FeatherSearch: "search",
  FeatherSection: "section",
  FeatherSendHorizontal: "send-horizontal",
  FeatherSendToBack: "send-to-back",
  FeatherSend: "send",
  FeatherSeparatorHorizontal: "separator-horizontal",
  FeatherSeparatorVertical: "separator-vertical",
  FeatherServerCog: "server-cog",
  FeatherServerCrash: "server-crash",
  FeatherServerOff: "server-off",
  FeatherServer: "server",
  FeatherSettings2: "settings-2",
  FeatherSettings: "settings",
  FeatherShadowLarge: "shadow-large",
  FeatherShadowMedium: "shadow-medium",
  FeatherShadowSmall: "shadow-small",
  FeatherShapes: "shapes",
  FeatherShare2: "share-2",
  FeatherShare: "share",
  FeatherSheet: "sheet",
  FeatherShell: "shell",
  FeatherShieldAlert: "shield-alert",
  FeatherShieldBan: "shield-ban",
  FeatherShieldCheck: "shield-check",
  FeatherShieldClose: "shield-close",
  FeatherShieldEllipsis: "shield-ellipsis",
  FeatherShieldHalf: "shield-half",
  FeatherShieldMinus: "shield-minus",
  FeatherShieldOff: "shield-off",
  FeatherShieldPlus: "shield-plus",
  FeatherShieldQuestionMark: "shield-question-mark",
  FeatherShieldQuestion: "shield-question",
  FeatherShieldUser: "shield-user",
  FeatherShieldX: "shield-x",
  FeatherShield: "shield",
  FeatherShipWheel: "ship-wheel",
  FeatherShip: "ship",
  FeatherShirt: "shirt",
  FeatherShoppingBag: "shopping-bag",
  FeatherShoppingBasket: "shopping-basket",
  FeatherShoppingCart: "shopping-cart",
  FeatherShovel: "shovel",
  FeatherShowerHead: "shower-head",
  FeatherShredder: "shredder",
  FeatherShrimp: "shrimp",
  FeatherShrink: "shrink",
  FeatherShrub: "shrub",
  FeatherShuffle: "shuffle",
  FeatherSidebarClose: "sidebar-close",
  FeatherSidebarOpen: "sidebar-open",
  FeatherSidebar: "sidebar",
  FeatherSigmaSquare: "sigma-square",
  FeatherSigma: "sigma",
  FeatherSignalHigh: "signal-high",
  FeatherSignalLow: "signal-low",
  FeatherSignalMedium: "signal-medium",
  FeatherSignalZero: "signal-zero",
  FeatherSignal: "signal",
  FeatherSignature: "signature",
  FeatherSignpostBig: "signpost-big",
  FeatherSignpost: "signpost",
  FeatherSiren: "siren",
  FeatherSkipBack: "skip-back",
  FeatherSkipForward: "skip-forward",
  FeatherSkull: "skull",
  FeatherSlack: "slack",
  FeatherSlash: "slash",
  FeatherSlice: "slice",
  FeatherSlidersHorizontal: "sliders-horizontal",
  FeatherSliders: "sliders",
  FeatherSmartphoneCharging: "smartphone-charging",
  FeatherSmartphoneNfc: "smartphone-nfc",
  FeatherSmartphone: "smartphone",
  FeatherSmilePlus: "smile-plus",
  FeatherSmile: "smile",
  FeatherSnail: "snail",
  FeatherSnowflake: "snowflake",
  FeatherSoapDispenserDroplet: "soap-dispenser-droplet",
  FeatherSofa: "sofa",
  FeatherSortAsc: "sort-asc",
  FeatherSortDesc: "sort-desc",
  FeatherSoup: "soup",
  FeatherSpace: "space",
  FeatherSpade: "spade",
  FeatherSparkle: "sparkle",
  FeatherSparkles: "sparkles",
  FeatherSpeaker: "speaker",
  FeatherSpeech: "speech",
  FeatherSpellCheck2: "spell-check-2",
  FeatherSpellCheck: "spell-check",
  FeatherSplinePointer: "spline-pointer",
  FeatherSpline: "spline",
  FeatherSplitSquareHorizontal: "split-square-horizontal",
  FeatherSplitSquareVertical: "split-square-vertical",
  FeatherSplit: "split",
  FeatherSpool: "spool",
  FeatherSprayCan: "spray-can",
  FeatherSprout: "sprout",
  FeatherSquareArrowOutDownLeft: "square-arrow-out-down-left",
  FeatherSquareArrowOutDownRight: "square-arrow-out-down-right",
  FeatherSquareArrowOutUpLeft: "square-arrow-out-up-left",
  FeatherSquareArrowOutUpRight: "square-arrow-out-up-right",
  FeatherSquareAsterisk: "square-asterisk",
  FeatherSquareCheckBig: "square-check-big",
  FeatherSquareCheck: "square-check",
  FeatherSquareCode: "square-code",
  FeatherSquareCornerBl: "square-corner-bl",
  FeatherSquareCornerBrBl: "square-corner-br-bl",
  FeatherSquareCornerBr: "square-corner-br",
  FeatherSquareCornerTlBl: "square-corner-tl-bl",
  FeatherSquareCornerTlBrBl: "square-corner-tl-br-bl",
  FeatherSquareCornerTlBr: "square-corner-tl-br",
  FeatherSquareCornerTlTrBl: "square-corner-tl-tr-bl",
  FeatherSquareCornerTlTrBr: "square-corner-tl-tr-br",
  FeatherSquareCornerTl: "square-corner-tl",
  FeatherSquareCornerTrBl: "square-corner-tr-bl",
  FeatherSquareCornerTrBrBl: "square-corner-tr-br-bl",
  FeatherSquareCornerTrBr: "square-corner-tr-br",
  FeatherSquareCornerTrTl: "square-corner-tr-tl",
  FeatherSquareCornerTr: "square-corner-tr",
  FeatherSquareCorner: "square-corner",
  FeatherSquareDashedBottomCode: "square-dashed-bottom-code",
  FeatherSquareDashedBottom: "square-dashed-bottom",
  FeatherSquareDashedMousePointer: "square-dashed-mouse-pointer",
  FeatherSquareDashedTopSolid: "square-dashed-top-solid",
  FeatherSquareDot: "square-dot",
  FeatherSquareEqual: "square-equal",
  FeatherSquareMousePointer: "square-mouse-pointer",
  FeatherSquarePen: "square-pen",
  FeatherSquarePower: "square-power",
  FeatherSquareRadical: "square-radical",
  FeatherSquareRoundCorner: "square-round-corner",
  FeatherSquareSidesBottom: "square-sides-bottom",
  FeatherSquareSidesLeftBottom: "square-sides-left-bottom",
  FeatherSquareSidesLeftRightBottom: "square-sides-left-right-bottom",
  FeatherSquareSidesLeftRight: "square-sides-left-right",
  FeatherSquareSidesLeftTopBottom: "square-sides-left-top-bottom",
  FeatherSquareSidesLeftTopRight: "square-sides-left-top-right",
  FeatherSquareSidesLeftTop: "square-sides-left-top",
  FeatherSquareSidesLeft: "square-sides-left",
  FeatherSquareSidesRightBottom: "square-sides-right-bottom",
  FeatherSquareSidesRight: "square-sides-right",
  FeatherSquareSidesTopBottom: "square-sides-top-bottom",
  FeatherSquareSidesTopRightBottom: "square-sides-top-right-bottom",
  FeatherSquareSidesTopRight: "square-sides-top-right",
  FeatherSquareSidesTop: "square-sides-top",
  FeatherSquareSides: "square-sides",
  FeatherSquareSlash: "square-slash",
  FeatherSquareSquare: "square-square",
  FeatherSquareStack: "square-stack",
  FeatherSquare: "square",
  FeatherSquaresExclude: "squares-exclude",
  FeatherSquaresIntersect: "squares-intersect",
  FeatherSquaresSubtract: "squares-subtract",
  FeatherSquaresUnite: "squares-unite",
  FeatherSquircleDashed: "squircle-dashed",
  FeatherSquircle: "squircle",
  FeatherSquirrel: "squirrel",
  FeatherStamp: "stamp",
  FeatherStarHalf: "star-half",
  FeatherStarOff: "star-off",
  FeatherStar: "star",
  FeatherStepBack: "step-back",
  FeatherStepForward: "step-forward",
  FeatherStethoscope: "stethoscope",
  FeatherSticker: "sticker",
  FeatherStickyNote: "sticky-note",
  FeatherStopCircle: "stop-circle",
  FeatherStore: "store",
  FeatherStretchHorizontal: "stretch-horizontal",
  FeatherStretchVertical: "stretch-vertical",
  FeatherStrikethrough: "strikethrough",
  FeatherSubframe: "subframe",
  FeatherSubscript: "subscript",
  FeatherSubtitles: "subtitles",
  FeatherSunDim: "sun-dim",
  FeatherSunMedium: "sun-medium",
  FeatherSunMoon: "sun-moon",
  FeatherSunSnow: "sun-snow",
  FeatherSun: "sun",
  FeatherSunrise: "sunrise",
  FeatherSunset: "sunset",
  FeatherSuperscript: "superscript",
  FeatherSwatchBook: "swatch-book",
  FeatherSwissFranc: "swiss-franc",
  FeatherSwitchCamera: "switch-camera",
  FeatherSword: "sword",
  FeatherSwords: "swords",
  FeatherSyringe: "syringe",
  FeatherTable2: "table-2",
  FeatherTableCellsMerge: "table-cells-merge",
  FeatherTableCellsSplit: "table-cells-split",
  FeatherTableColumnsSplit: "table-columns-split",
  FeatherTableOfContents: "table-of-contents",
  FeatherTableProperties: "table-properties",
  FeatherTableRowsSplit: "table-rows-split",
  FeatherTable: "table",
  FeatherTabletSmartphone: "tablet-smartphone",
  FeatherTablet: "tablet",
  FeatherTablets: "tablets",
  FeatherTag: "tag",
  FeatherTags: "tags",
  FeatherTally1: "tally-1",
  FeatherTally2: "tally-2",
  FeatherTally3: "tally-3",
  FeatherTally4: "tally-4",
  FeatherTally5: "tally-5",
  FeatherTangent: "tangent",
  FeatherTarget: "target",
  FeatherTelescope: "telescope",
  FeatherTentTree: "tent-tree",
  FeatherTent: "tent",
  FeatherTerminalSquare: "terminal-square",
  FeatherTerminal: "terminal",
  FeatherTestTube2: "test-tube-2",
  FeatherTestTubeDiagonal: "test-tube-diagonal",
  FeatherTestTube: "test-tube",
  FeatherTestTubes: "test-tubes",
  FeatherTextCursorInput: "text-cursor-input",
  FeatherTextCursor: "text-cursor",
  FeatherTextQuote: "text-quote",
  FeatherTextSearch: "text-search",
  FeatherTextSelect: "text-select",
  FeatherTextSize: "text-size",
  FeatherTextTruncate: "text-truncate",
  FeatherText: "text",
  FeatherTheater: "theater",
  FeatherThermometerSnowflake: "thermometer-snowflake",
  FeatherThermometerSun: "thermometer-sun",
  FeatherThermometer: "thermometer",
  FeatherThumbsDown: "thumbs-down",
  FeatherThumbsUp: "thumbs-up",
  FeatherTicketCheck: "ticket-check",
  FeatherTicketMinus: "ticket-minus",
  FeatherTicketPercent: "ticket-percent",
  FeatherTicketPlus: "ticket-plus",
  FeatherTicketSlash: "ticket-slash",
  FeatherTicketX: "ticket-x",
  FeatherTicket: "ticket",
  FeatherTicketsPlane: "tickets-plane",
  FeatherTickets: "tickets",
  FeatherTimerOff: "timer-off",
  FeatherTimerReset: "timer-reset",
  FeatherTimer: "timer",
  FeatherToggleLeft: "toggle-left",
  FeatherToggleRight: "toggle-right",
  FeatherToilet: "toilet",
  FeatherTool: "tool",
  FeatherTornado: "tornado",
  FeatherTorus: "torus",
  FeatherTouchpadOff: "touchpad-off",
  FeatherTouchpad: "touchpad",
  FeatherTowerControl: "tower-control",
  FeatherToyBrick: "toy-brick",
  FeatherTractor: "tractor",
  FeatherTrafficCone: "traffic-cone",
  FeatherTrainFrontTunnel: "train-front-tunnel",
  FeatherTrainFront: "train-front",
  FeatherTrainTrack: "train-track",
  FeatherTrain: "train",
  FeatherTramFront: "tram-front",
  FeatherTransgender: "transgender",
  FeatherTrash2: "trash-2",
  FeatherTrash: "trash",
  FeatherTreeDeciduous: "tree-deciduous",
  FeatherTreePalm: "tree-palm",
  FeatherTreePine: "tree-pine",
  FeatherTrees: "trees",
  FeatherTrello: "trello",
  FeatherTrendingDown: "trending-down",
  FeatherTrendingUpDown: "trending-up-down",
  FeatherTrendingUp: "trending-up",
  FeatherTriangleAlert: "triangle-alert",
  FeatherTriangleDashed: "triangle-dashed",
  FeatherTriangleRight: "triangle-right",
  FeatherTriangle: "triangle",
  FeatherTrophy: "trophy",
  FeatherTruckElectric: "truck-electric",
  FeatherTruck: "truck",
  FeatherTurtle: "turtle",
  FeatherTv2: "tv-2",
  FeatherTvMinimalPlay: "tv-minimal-play",
  FeatherTv: "tv",
  FeatherTwitch: "twitch",
  FeatherTwitter: "twitter",
  FeatherTypeOutline: "type-outline",
  FeatherType: "type",
  FeatherUmbrellaOff: "umbrella-off",
  FeatherUmbrella: "umbrella",
  FeatherUnderline: "underline",
  FeatherUndo2: "undo-2",
  FeatherUndoDot: "undo-dot",
  FeatherUndo: "undo",
  FeatherUnfoldHorizontal: "unfold-horizontal",
  FeatherUnfoldVertical: "unfold-vertical",
  FeatherUngroup: "ungroup",
  FeatherUniversity: "university",
  FeatherUnlink2: "unlink-2",
  FeatherUnlink: "unlink",
  FeatherUnlockKeyhole: "unlock-keyhole",
  FeatherUnlock: "unlock",
  FeatherUnplug: "unplug",
  FeatherUploadCloud: "upload-cloud",
  FeatherUpload: "upload",
  FeatherUsb: "usb",
  FeatherUser2: "user-2",
  FeatherUserCheck2: "user-check-2",
  FeatherUserCheck: "user-check",
  FeatherUserCircle2: "user-circle-2",
  FeatherUserCircle: "user-circle",
  FeatherUserCog2: "user-cog-2",
  FeatherUserCog: "user-cog",
  FeatherUserLock: "user-lock",
  FeatherUserMinus2: "user-minus-2",
  FeatherUserMinus: "user-minus",
  FeatherUserPen: "user-pen",
  FeatherUserPlus2: "user-plus-2",
  FeatherUserPlus: "user-plus",
  FeatherUserRoundCheck: "user-round-check",
  FeatherUserRoundCog: "user-round-cog",
  FeatherUserRoundMinus: "user-round-minus",
  FeatherUserRoundPen: "user-round-pen",
  FeatherUserRoundPlus: "user-round-plus",
  FeatherUserRoundSearch: "user-round-search",
  FeatherUserRoundX: "user-round-x",
  FeatherUserRound: "user-round",
  FeatherUserSearch: "user-search",
  FeatherUserSquare2: "user-square-2",
  FeatherUserSquare: "user-square",
  FeatherUserX2: "user-x-2",
  FeatherUserX: "user-x",
  FeatherUser: "user",
  FeatherUsers2: "users-2",
  FeatherUsersRound: "users-round",
  FeatherUsers: "users",
  FeatherUtensilsCrossed: "utensils-crossed",
  FeatherUtensils: "utensils",
  FeatherUtilityPole: "utility-pole",
  FeatherVariable: "variable",
  FeatherVault: "vault",
  FeatherVegan: "vegan",
  FeatherVenetianMask: "venetian-mask",
  FeatherVenusAndMars: "venus-and-mars",
  FeatherVenus: "venus",
  FeatherVerified: "verified",
  FeatherVibrateOff: "vibrate-off",
  FeatherVibrate: "vibrate",
  FeatherVideoOff: "video-off",
  FeatherVideo: "video",
  FeatherVideotape: "videotape",
  FeatherView: "view",
  FeatherVoicemail: "voicemail",
  FeatherVolleyball: "volleyball",
  FeatherVolume1: "volume-1",
  FeatherVolume2: "volume-2",
  FeatherVolumeOff: "volume-off",
  FeatherVolumeX: "volume-x",
  FeatherVolume: "volume",
  FeatherVote: "vote",
  FeatherWallet2: "wallet-2",
  FeatherWalletCards: "wallet-cards",
  FeatherWallet: "wallet",
  FeatherWallpaper: "wallpaper",
  FeatherWand2: "wand-2",
  FeatherWandSparkles: "wand-sparkles",
  FeatherWand: "wand",
  FeatherWarehouse: "warehouse",
  FeatherWashingMachine: "washing-machine",
  FeatherWatch: "watch",
  FeatherWavesLadder: "waves-ladder",
  FeatherWaves: "waves",
  FeatherWaypoints: "waypoints",
  FeatherWebcam: "webcam",
  FeatherWebhookOff: "webhook-off",
  FeatherWebhook: "webhook",
  FeatherWeight: "weight",
  FeatherWheatOff: "wheat-off",
  FeatherWheat: "wheat",
  FeatherWholeWord: "whole-word",
  FeatherWifiCog: "wifi-cog",
  FeatherWifiHigh: "wifi-high",
  FeatherWifiLow: "wifi-low",
  FeatherWifiOff: "wifi-off",
  FeatherWifiPen: "wifi-pen",
  FeatherWifiZero: "wifi-zero",
  FeatherWifi: "wifi",
  FeatherWindArrowDown: "wind-arrow-down",
  FeatherWind: "wind",
  FeatherWineOff: "wine-off",
  FeatherWine: "wine",
  FeatherWorkflow: "workflow",
  FeatherWorm: "worm",
  FeatherWrapText: "wrap-text",
  FeatherWrench: "wrench",
  FeatherXCircle: "x-circle",
  FeatherXOctagon: "x-octagon",
  FeatherXSquare: "x-square",
  FeatherXTwitter: "x-twitter",
  FeatherX: "x",
  FeatherYoutube: "youtube",
  FeatherZapOff: "zap-off",
  FeatherZap: "zap",
  FeatherZoomIn: "zoom-in",
  FeatherZoomOut: "zoom-out",
  SubframeSides: "subframe-sides",
  empty: "empty",
} as const;

export const iconOptions: { label: string; value: string }[] = [
  { label: "A Arrow Down", value: "FeatherAArrowDown" },
  { label: "A Arrow Up", value: "FeatherAArrowUp" },
  { label: "A Large Small", value: "FeatherALargeSmall" },
  { label: "Accessibility", value: "FeatherAccessibility" },
  { label: "Activity Square", value: "FeatherActivitySquare" },
  { label: "Activity", value: "FeatherActivity" },
  { label: "Air Vent", value: "FeatherAirVent" },
  { label: "Airplay", value: "FeatherAirplay" },
  { label: "Alarm Check", value: "FeatherAlarmCheck" },
  { label: "Alarm Clock Off", value: "FeatherAlarmClockOff" },
  { label: "Alarm Clock", value: "FeatherAlarmClock" },
  { label: "Alarm Minus", value: "FeatherAlarmMinus" },
  { label: "Alarm Plus", value: "FeatherAlarmPlus" },
  { label: "Alarm Smoke", value: "FeatherAlarmSmoke" },
  { label: "Album", value: "FeatherAlbum" },
  { label: "Alert Circle", value: "FeatherAlertCircle" },
  { label: "Alert Octagon", value: "FeatherAlertOctagon" },
  { label: "Alert Triangle", value: "FeatherAlertTriangle" },
  { label: "Align Center Horizontal", value: "FeatherAlignCenterHorizontal" },
  { label: "Align Center Vertical", value: "FeatherAlignCenterVertical" },
  { label: "Align Center", value: "FeatherAlignCenter" },
  { label: "Align End Horizontal", value: "FeatherAlignEndHorizontal" },
  { label: "Align End Vertical", value: "FeatherAlignEndVertical" },
  { label: "Align H Bottom Left", value: "FeatherAlignHBottomLeft" },
  { label: "Align H Bottom Right", value: "FeatherAlignHBottomRight" },
  { label: "Align H Bottom", value: "FeatherAlignHBottom" },
  { label: "Align H Center", value: "FeatherAlignHCenter" },
  { label: "Align H Left", value: "FeatherAlignHLeft" },
  { label: "Align H Right", value: "FeatherAlignHRight" },
  { label: "Align H Top Left", value: "FeatherAlignHTopLeft" },
  { label: "Align H Top Right", value: "FeatherAlignHTopRight" },
  { label: "Align H Top", value: "FeatherAlignHTop" },
  {
    label: "Align Horizontal Distribute Center",
    value: "FeatherAlignHorizontalDistributeCenter",
  },
  {
    label: "Align Horizontal Distribute End",
    value: "FeatherAlignHorizontalDistributeEnd",
  },
  {
    label: "Align Horizontal Distribute Start",
    value: "FeatherAlignHorizontalDistributeStart",
  },
  {
    label: "Align Horizontal Justify Center",
    value: "FeatherAlignHorizontalJustifyCenter",
  },
  {
    label: "Align Horizontal Justify End",
    value: "FeatherAlignHorizontalJustifyEnd",
  },
  {
    label: "Align Horizontal Justify Start",
    value: "FeatherAlignHorizontalJustifyStart",
  },
  {
    label: "Align Horizontal Space Around",
    value: "FeatherAlignHorizontalSpaceAround",
  },
  {
    label: "Align Horizontal Space Between",
    value: "FeatherAlignHorizontalSpaceBetween",
  },
  { label: "Align Justify", value: "FeatherAlignJustify" },
  { label: "Align Left", value: "FeatherAlignLeft" },
  { label: "Align Right", value: "FeatherAlignRight" },
  { label: "Align Start Horizontal", value: "FeatherAlignStartHorizontal" },
  { label: "Align Start Vertical", value: "FeatherAlignStartVertical" },
  { label: "Align V Bottom Left", value: "FeatherAlignVBottomLeft" },
  { label: "Align V Bottom Right", value: "FeatherAlignVBottomRight" },
  { label: "Align V Bottom", value: "FeatherAlignVBottom" },
  { label: "Align V Center", value: "FeatherAlignVCenter" },
  { label: "Align V Left", value: "FeatherAlignVLeft" },
  { label: "Align V Right", value: "FeatherAlignVRight" },
  { label: "Align V Top Left", value: "FeatherAlignVTopLeft" },
  { label: "Align V Top Right", value: "FeatherAlignVTopRight" },
  { label: "Align V Top", value: "FeatherAlignVTop" },
  {
    label: "Align Vertical Distribute Center",
    value: "FeatherAlignVerticalDistributeCenter",
  },
  {
    label: "Align Vertical Distribute End",
    value: "FeatherAlignVerticalDistributeEnd",
  },
  {
    label: "Align Vertical Distribute Start",
    value: "FeatherAlignVerticalDistributeStart",
  },
  {
    label: "Align Vertical Justify Center",
    value: "FeatherAlignVerticalJustifyCenter",
  },
  {
    label: "Align Vertical Justify End",
    value: "FeatherAlignVerticalJustifyEnd",
  },
  {
    label: "Align Vertical Justify Start",
    value: "FeatherAlignVerticalJustifyStart",
  },
  {
    label: "Align Vertical Space Around",
    value: "FeatherAlignVerticalSpaceAround",
  },
  {
    label: "Align Vertical Space Between",
    value: "FeatherAlignVerticalSpaceBetween",
  },
  { label: "Ambulance", value: "FeatherAmbulance" },
  { label: "Ampersand", value: "FeatherAmpersand" },
  { label: "Ampersands", value: "FeatherAmpersands" },
  { label: "Amphora", value: "FeatherAmphora" },
  { label: "Anchor", value: "FeatherAnchor" },
  { label: "Angry", value: "FeatherAngry" },
  { label: "Annoyed", value: "FeatherAnnoyed" },
  { label: "Antenna", value: "FeatherAntenna" },
  { label: "Anvil", value: "FeatherAnvil" },
  { label: "Aperture", value: "FeatherAperture" },
  { label: "App Window Mac", value: "FeatherAppWindowMac" },
  { label: "App Window", value: "FeatherAppWindow" },
  { label: "Apple", value: "FeatherApple" },
  { label: "Archive Restore", value: "FeatherArchiveRestore" },
  { label: "Archive X", value: "FeatherArchiveX" },
  { label: "Archive", value: "FeatherArchive" },
  { label: "Area Chart", value: "FeatherAreaChart" },
  { label: "Armchair", value: "FeatherArmchair" },
  { label: "Arrow Big Down Dash", value: "FeatherArrowBigDownDash" },
  { label: "Arrow Big Down", value: "FeatherArrowBigDown" },
  { label: "Arrow Big Left Dash", value: "FeatherArrowBigLeftDash" },
  { label: "Arrow Big Left", value: "FeatherArrowBigLeft" },
  { label: "Arrow Big Right Dash", value: "FeatherArrowBigRightDash" },
  { label: "Arrow Big Right", value: "FeatherArrowBigRight" },
  { label: "Arrow Big Up Dash", value: "FeatherArrowBigUpDash" },
  { label: "Arrow Big Up", value: "FeatherArrowBigUp" },
  { label: "Arrow Down 0 1", value: "FeatherArrowDown01" },
  { label: "Arrow Down 1 0", value: "FeatherArrowDown10" },
  { label: "Arrow Down A Z", value: "FeatherArrowDownAZ" },
  { label: "Arrow Down Circle", value: "FeatherArrowDownCircle" },
  { label: "Arrow Down From Line", value: "FeatherArrowDownFromLine" },
  {
    label: "Arrow Down Left From Circle",
    value: "FeatherArrowDownLeftFromCircle",
  },
  { label: "Arrow Down Left Square", value: "FeatherArrowDownLeftSquare" },
  { label: "Arrow Down Left", value: "FeatherArrowDownLeft" },
  { label: "Arrow Down Narrow Wide", value: "FeatherArrowDownNarrowWide" },
  {
    label: "Arrow Down Right From Circle",
    value: "FeatherArrowDownRightFromCircle",
  },
  { label: "Arrow Down Right Square", value: "FeatherArrowDownRightSquare" },
  { label: "Arrow Down Right", value: "FeatherArrowDownRight" },
  { label: "Arrow Down Square", value: "FeatherArrowDownSquare" },
  { label: "Arrow Down To Dot", value: "FeatherArrowDownToDot" },
  { label: "Arrow Down To Line", value: "FeatherArrowDownToLine" },
  { label: "Arrow Down Up", value: "FeatherArrowDownUp" },
  { label: "Arrow Down Wide Narrow", value: "FeatherArrowDownWideNarrow" },
  { label: "Arrow Down Z A", value: "FeatherArrowDownZA" },
  { label: "Arrow Down", value: "FeatherArrowDown" },
  { label: "Arrow Left Circle", value: "FeatherArrowLeftCircle" },
  { label: "Arrow Left From Line", value: "FeatherArrowLeftFromLine" },
  { label: "Arrow Left Right", value: "FeatherArrowLeftRight" },
  { label: "Arrow Left Square", value: "FeatherArrowLeftSquare" },
  { label: "Arrow Left To Line", value: "FeatherArrowLeftToLine" },
  { label: "Arrow Left", value: "FeatherArrowLeft" },
  { label: "Arrow Right Circle", value: "FeatherArrowRightCircle" },
  { label: "Arrow Right From Line", value: "FeatherArrowRightFromLine" },
  { label: "Arrow Right Left", value: "FeatherArrowRightLeft" },
  { label: "Arrow Right Square", value: "FeatherArrowRightSquare" },
  { label: "Arrow Right To Line", value: "FeatherArrowRightToLine" },
  { label: "Arrow Right", value: "FeatherArrowRight" },
  { label: "Arrow Up 0 1", value: "FeatherArrowUp01" },
  { label: "Arrow Up 1 0", value: "FeatherArrowUp10" },
  { label: "Arrow Up A Z", value: "FeatherArrowUpAZ" },
  { label: "Arrow Up Circle", value: "FeatherArrowUpCircle" },
  { label: "Arrow Up Down", value: "FeatherArrowUpDown" },
  { label: "Arrow Up From Dot", value: "FeatherArrowUpFromDot" },
  { label: "Arrow Up From Line", value: "FeatherArrowUpFromLine" },
  { label: "Arrow Up Left From Circle", value: "FeatherArrowUpLeftFromCircle" },
  { label: "Arrow Up Left Square", value: "FeatherArrowUpLeftSquare" },
  { label: "Arrow Up Left", value: "FeatherArrowUpLeft" },
  { label: "Arrow Up Narrow Wide", value: "FeatherArrowUpNarrowWide" },
  {
    label: "Arrow Up Right From Circle",
    value: "FeatherArrowUpRightFromCircle",
  },
  { label: "Arrow Up Right Square", value: "FeatherArrowUpRightSquare" },
  { label: "Arrow Up Right", value: "FeatherArrowUpRight" },
  { label: "Arrow Up Square", value: "FeatherArrowUpSquare" },
  { label: "Arrow Up To Line", value: "FeatherArrowUpToLine" },
  { label: "Arrow Up Wide Narrow", value: "FeatherArrowUpWideNarrow" },
  { label: "Arrow Up Z A", value: "FeatherArrowUpZA" },
  { label: "Arrow Up", value: "FeatherArrowUp" },
  { label: "Arrows Up From Line", value: "FeatherArrowsUpFromLine" },
  { label: "Asterisk", value: "FeatherAsterisk" },
  { label: "At Sign", value: "FeatherAtSign" },
  { label: "Atom", value: "FeatherAtom" },
  { label: "Audio Lines", value: "FeatherAudioLines" },
  { label: "Audio Waveform", value: "FeatherAudioWaveform" },
  { label: "Award", value: "FeatherAward" },
  { label: "Axe", value: "FeatherAxe" },
  { label: "Axis 3d", value: "FeatherAxis3D" },
  { label: "Baby", value: "FeatherBaby" },
  { label: "Backpack", value: "FeatherBackpack" },
  { label: "Badge Alert", value: "FeatherBadgeAlert" },
  { label: "Badge Cent", value: "FeatherBadgeCent" },
  { label: "Badge Check", value: "FeatherBadgeCheck" },
  { label: "Badge Dollar Sign", value: "FeatherBadgeDollarSign" },
  { label: "Badge Euro", value: "FeatherBadgeEuro" },
  { label: "Badge Help", value: "FeatherBadgeHelp" },
  { label: "Badge Indian Rupee", value: "FeatherBadgeIndianRupee" },
  { label: "Badge Info", value: "FeatherBadgeInfo" },
  { label: "Badge Japanese Yen", value: "FeatherBadgeJapaneseYen" },
  { label: "Badge Minus", value: "FeatherBadgeMinus" },
  { label: "Badge Percent", value: "FeatherBadgePercent" },
  { label: "Badge Plus", value: "FeatherBadgePlus" },
  { label: "Badge Pound Sterling", value: "FeatherBadgePoundSterling" },
  { label: "Badge Russian Ruble", value: "FeatherBadgeRussianRuble" },
  { label: "Badge Swiss Franc", value: "FeatherBadgeSwissFranc" },
  { label: "Badge X", value: "FeatherBadgeX" },
  { label: "Badge", value: "FeatherBadge" },
  { label: "Baggage Claim", value: "FeatherBaggageClaim" },
  { label: "Ban", value: "FeatherBan" },
  { label: "Banana", value: "FeatherBanana" },
  { label: "Bandage", value: "FeatherBandage" },
  { label: "Banknote Arrow Down", value: "FeatherBanknoteArrowDown" },
  { label: "Banknote Arrow Up", value: "FeatherBanknoteArrowUp" },
  { label: "Banknote X", value: "FeatherBanknoteX" },
  { label: "Banknote", value: "FeatherBanknote" },
  { label: "Bar Chart 2", value: "FeatherBarChart2" },
  { label: "Bar Chart 3", value: "FeatherBarChart3" },
  { label: "Bar Chart 4", value: "FeatherBarChart4" },
  { label: "Bar Chart Big", value: "FeatherBarChartBig" },
  { label: "Bar Chart Horizontal Big", value: "FeatherBarChartHorizontalBig" },
  { label: "Bar Chart Horizontal", value: "FeatherBarChartHorizontal" },
  { label: "Bar Chart", value: "FeatherBarChart" },
  { label: "Barcode", value: "FeatherBarcode" },
  { label: "Barrel", value: "FeatherBarrel" },
  { label: "Baseline", value: "FeatherBaseline" },
  { label: "Bath", value: "FeatherBath" },
  { label: "Battery Charging", value: "FeatherBatteryCharging" },
  { label: "Battery Full", value: "FeatherBatteryFull" },
  { label: "Battery Low", value: "FeatherBatteryLow" },
  { label: "Battery Medium", value: "FeatherBatteryMedium" },
  { label: "Battery Plus", value: "FeatherBatteryPlus" },
  { label: "Battery Warning", value: "FeatherBatteryWarning" },
  { label: "Battery", value: "FeatherBattery" },
  { label: "Beaker", value: "FeatherBeaker" },
  { label: "Bean Off", value: "FeatherBeanOff" },
  { label: "Bean", value: "FeatherBean" },
  { label: "Bed Double", value: "FeatherBedDouble" },
  { label: "Bed Single", value: "FeatherBedSingle" },
  { label: "Bed", value: "FeatherBed" },
  { label: "Beef", value: "FeatherBeef" },
  { label: "Beer Off", value: "FeatherBeerOff" },
  { label: "Beer", value: "FeatherBeer" },
  { label: "Bell Dot", value: "FeatherBellDot" },
  { label: "Bell Electric", value: "FeatherBellElectric" },
  { label: "Bell Minus", value: "FeatherBellMinus" },
  { label: "Bell Off", value: "FeatherBellOff" },
  { label: "Bell Plus", value: "FeatherBellPlus" },
  { label: "Bell Ring", value: "FeatherBellRing" },
  { label: "Bell", value: "FeatherBell" },
  { label: "Between Horizontal End", value: "FeatherBetweenHorizontalEnd" },
  { label: "Between Horizontal Start", value: "FeatherBetweenHorizontalStart" },
  { label: "Between Vertical End", value: "FeatherBetweenVerticalEnd" },
  { label: "Between Vertical Start", value: "FeatherBetweenVerticalStart" },
  { label: "Biceps Flexed", value: "FeatherBicepsFlexed" },
  { label: "Bike", value: "FeatherBike" },
  { label: "Binary", value: "FeatherBinary" },
  { label: "Binoculars", value: "FeatherBinoculars" },
  { label: "Biohazard", value: "FeatherBiohazard" },
  { label: "Bird", value: "FeatherBird" },
  { label: "Bitcoin", value: "FeatherBitcoin" },
  { label: "Blend", value: "FeatherBlend" },
  { label: "Blinds", value: "FeatherBlinds" },
  { label: "Blocks", value: "FeatherBlocks" },
  { label: "Bluetooth Connected", value: "FeatherBluetoothConnected" },
  { label: "Bluetooth Off", value: "FeatherBluetoothOff" },
  { label: "Bluetooth Searching", value: "FeatherBluetoothSearching" },
  { label: "Bluetooth", value: "FeatherBluetooth" },
  { label: "Bold", value: "FeatherBold" },
  { label: "Bolt", value: "FeatherBolt" },
  { label: "Bomb", value: "FeatherBomb" },
  { label: "Bone", value: "FeatherBone" },
  { label: "Book A", value: "FeatherBookA" },
  { label: "Book Alert", value: "FeatherBookAlert" },
  { label: "Book Audio", value: "FeatherBookAudio" },
  { label: "Book Check", value: "FeatherBookCheck" },
  { label: "Book Copy", value: "FeatherBookCopy" },
  { label: "Book Dashed", value: "FeatherBookDashed" },
  { label: "Book Down", value: "FeatherBookDown" },
  { label: "Book Headphones", value: "FeatherBookHeadphones" },
  { label: "Book Heart", value: "FeatherBookHeart" },
  { label: "Book Image", value: "FeatherBookImage" },
  { label: "Book Key", value: "FeatherBookKey" },
  { label: "Book Lock", value: "FeatherBookLock" },
  { label: "Book Marked", value: "FeatherBookMarked" },
  { label: "Book Minus", value: "FeatherBookMinus" },
  { label: "Book Open Check", value: "FeatherBookOpenCheck" },
  { label: "Book Open Text", value: "FeatherBookOpenText" },
  { label: "Book Open", value: "FeatherBookOpen" },
  { label: "Book Plus", value: "FeatherBookPlus" },
  { label: "Book Text", value: "FeatherBookText" },
  { label: "Book Type", value: "FeatherBookType" },
  { label: "Book Up 2", value: "FeatherBookUp2" },
  { label: "Book Up", value: "FeatherBookUp" },
  { label: "Book User", value: "FeatherBookUser" },
  { label: "Book X", value: "FeatherBookX" },
  { label: "Book", value: "FeatherBook" },
  { label: "Bookmark Check", value: "FeatherBookmarkCheck" },
  { label: "Bookmark Minus", value: "FeatherBookmarkMinus" },
  { label: "Bookmark Plus", value: "FeatherBookmarkPlus" },
  { label: "Bookmark X", value: "FeatherBookmarkX" },
  { label: "Bookmark", value: "FeatherBookmark" },
  { label: "Boom Box", value: "FeatherBoomBox" },
  { label: "Bot Message Square", value: "FeatherBotMessageSquare" },
  { label: "Bot Off", value: "FeatherBotOff" },
  { label: "Bot", value: "FeatherBot" },
  { label: "Bottle Wine", value: "FeatherBottleWine" },
  { label: "Bow Arrow", value: "FeatherBowArrow" },
  { label: "Box Select", value: "FeatherBoxSelect" },
  { label: "Box", value: "FeatherBox" },
  { label: "Boxes", value: "FeatherBoxes" },
  { label: "Braces", value: "FeatherBraces" },
  { label: "Brackets", value: "FeatherBrackets" },
  { label: "Brain Circuit", value: "FeatherBrainCircuit" },
  { label: "Brain Cog", value: "FeatherBrainCog" },
  { label: "Brain", value: "FeatherBrain" },
  { label: "Brick Wall Fire", value: "FeatherBrickWallFire" },
  { label: "Brick Wall", value: "FeatherBrickWall" },
  { label: "Briefcase Business", value: "FeatherBriefcaseBusiness" },
  { label: "Briefcase Conveyor Belt", value: "FeatherBriefcaseConveyorBelt" },
  { label: "Briefcase Medical", value: "FeatherBriefcaseMedical" },
  { label: "Briefcase", value: "FeatherBriefcase" },
  { label: "Bring To Front", value: "FeatherBringToFront" },
  { label: "Brush Cleaning", value: "FeatherBrushCleaning" },
  { label: "Brush", value: "FeatherBrush" },
  { label: "Bubbles", value: "FeatherBubbles" },
  { label: "Bug Off", value: "FeatherBugOff" },
  { label: "Bug Play", value: "FeatherBugPlay" },
  { label: "Bug", value: "FeatherBug" },
  { label: "Building 2", value: "FeatherBuilding2" },
  { label: "Building", value: "FeatherBuilding" },
  { label: "Bus Front", value: "FeatherBusFront" },
  { label: "Bus", value: "FeatherBus" },
  { label: "Cable Car", value: "FeatherCableCar" },
  { label: "Cable", value: "FeatherCable" },
  { label: "Cake Slice", value: "FeatherCakeSlice" },
  { label: "Cake", value: "FeatherCake" },
  { label: "Calculator", value: "FeatherCalculator" },
  { label: "Calendar 1", value: "FeatherCalendar1" },
  { label: "Calendar Arrow Down", value: "FeatherCalendarArrowDown" },
  { label: "Calendar Arrow Up", value: "FeatherCalendarArrowUp" },
  { label: "Calendar Check 2", value: "FeatherCalendarCheck2" },
  { label: "Calendar Check", value: "FeatherCalendarCheck" },
  { label: "Calendar Clock", value: "FeatherCalendarClock" },
  { label: "Calendar Cog", value: "FeatherCalendarCog" },
  { label: "Calendar Days", value: "FeatherCalendarDays" },
  { label: "Calendar Fold", value: "FeatherCalendarFold" },
  { label: "Calendar Heart", value: "FeatherCalendarHeart" },
  { label: "Calendar Minus 2", value: "FeatherCalendarMinus2" },
  { label: "Calendar Minus", value: "FeatherCalendarMinus" },
  { label: "Calendar Off", value: "FeatherCalendarOff" },
  { label: "Calendar Plus 2", value: "FeatherCalendarPlus2" },
  { label: "Calendar Plus", value: "FeatherCalendarPlus" },
  { label: "Calendar Range", value: "FeatherCalendarRange" },
  { label: "Calendar Search", value: "FeatherCalendarSearch" },
  { label: "Calendar Sync", value: "FeatherCalendarSync" },
  { label: "Calendar X 2", value: "FeatherCalendarX2" },
  { label: "Calendar X", value: "FeatherCalendarX" },
  { label: "Calendar", value: "FeatherCalendar" },
  { label: "Camera Off", value: "FeatherCameraOff" },
  { label: "Camera", value: "FeatherCamera" },
  { label: "Candlestick Chart", value: "FeatherCandlestickChart" },
  { label: "Candy Cane", value: "FeatherCandyCane" },
  { label: "Candy Off", value: "FeatherCandyOff" },
  { label: "Candy", value: "FeatherCandy" },
  { label: "Cannabis", value: "FeatherCannabis" },
  { label: "Captions Off", value: "FeatherCaptionsOff" },
  { label: "Captions", value: "FeatherCaptions" },
  { label: "Car Front", value: "FeatherCarFront" },
  { label: "Car Taxi Front", value: "FeatherCarTaxiFront" },
  { label: "Car", value: "FeatherCar" },
  { label: "Caravan", value: "FeatherCaravan" },
  { label: "Card Sim", value: "FeatherCardSim" },
  { label: "Carrot", value: "FeatherCarrot" },
  { label: "Case Lower", value: "FeatherCaseLower" },
  { label: "Case Sensitive", value: "FeatherCaseSensitive" },
  { label: "Case Upper", value: "FeatherCaseUpper" },
  { label: "Cassette Tape", value: "FeatherCassetteTape" },
  { label: "Cast", value: "FeatherCast" },
  { label: "Castle", value: "FeatherCastle" },
  { label: "Cat", value: "FeatherCat" },
  { label: "Cctv", value: "FeatherCctv" },
  { label: "Chart Area", value: "FeatherChartArea" },
  { label: "Chart Bar Big", value: "FeatherChartBarBig" },
  { label: "Chart Bar Decreasing", value: "FeatherChartBarDecreasing" },
  { label: "Chart Bar Increasing", value: "FeatherChartBarIncreasing" },
  { label: "Chart Bar Stacked", value: "FeatherChartBarStacked" },
  { label: "Chart Bar", value: "FeatherChartBar" },
  { label: "Chart Candlestick", value: "FeatherChartCandlestick" },
  { label: "Chart Column Big", value: "FeatherChartColumnBig" },
  { label: "Chart Column Decreasing", value: "FeatherChartColumnDecreasing" },
  { label: "Chart Column Increasing", value: "FeatherChartColumnIncreasing" },
  { label: "Chart Column Stacked", value: "FeatherChartColumnStacked" },
  { label: "Chart Column", value: "FeatherChartColumn" },
  { label: "Chart Gantt", value: "FeatherChartGantt" },
  { label: "Chart Line", value: "FeatherChartLine" },
  { label: "Chart Network", value: "FeatherChartNetwork" },
  {
    label: "Chart No Axes Column Decreasing",
    value: "FeatherChartNoAxesColumnDecreasing",
  },
  { label: "Chart No Axes Combined", value: "FeatherChartNoAxesCombined" },
  { label: "Chart Pie", value: "FeatherChartPie" },
  { label: "Chart Scatter", value: "FeatherChartScatter" },
  { label: "Chart Spline", value: "FeatherChartSpline" },
  { label: "Check Check", value: "FeatherCheckCheck" },
  { label: "Check Circle 2", value: "FeatherCheckCircle2" },
  { label: "Check Circle", value: "FeatherCheckCircle" },
  { label: "Check Line", value: "FeatherCheckLine" },
  { label: "Check Square", value: "FeatherCheckSquare" },
  { label: "Check", value: "FeatherCheck" },
  { label: "Chef Hat", value: "FeatherChefHat" },
  { label: "Cherry", value: "FeatherCherry" },
  { label: "Chevron Down Circle", value: "FeatherChevronDownCircle" },
  { label: "Chevron Down Square", value: "FeatherChevronDownSquare" },
  { label: "Chevron Down", value: "FeatherChevronDown" },
  { label: "Chevron First", value: "FeatherChevronFirst" },
  { label: "Chevron Last", value: "FeatherChevronLast" },
  { label: "Chevron Left Circle", value: "FeatherChevronLeftCircle" },
  { label: "Chevron Left Square", value: "FeatherChevronLeftSquare" },
  { label: "Chevron Left", value: "FeatherChevronLeft" },
  { label: "Chevron Right Circle", value: "FeatherChevronRightCircle" },
  { label: "Chevron Right Square", value: "FeatherChevronRightSquare" },
  { label: "Chevron Right", value: "FeatherChevronRight" },
  { label: "Chevron Up Circle", value: "FeatherChevronUpCircle" },
  { label: "Chevron Up Square", value: "FeatherChevronUpSquare" },
  { label: "Chevron Up", value: "FeatherChevronUp" },
  { label: "Chevrons Down Up", value: "FeatherChevronsDownUp" },
  { label: "Chevrons Down", value: "FeatherChevronsDown" },
  {
    label: "Chevrons Left Right Ellipsis",
    value: "FeatherChevronsLeftRightEllipsis",
  },
  { label: "Chevrons Left Right", value: "FeatherChevronsLeftRight" },
  { label: "Chevrons Left", value: "FeatherChevronsLeft" },
  { label: "Chevrons Right Left", value: "FeatherChevronsRightLeft" },
  { label: "Chevrons Right", value: "FeatherChevronsRight" },
  { label: "Chevrons Up Down", value: "FeatherChevronsUpDown" },
  { label: "Chevrons Up", value: "FeatherChevronsUp" },
  { label: "Chrome", value: "FeatherChrome" },
  { label: "Church", value: "FeatherChurch" },
  { label: "Cigarette Off", value: "FeatherCigaretteOff" },
  { label: "Cigarette", value: "FeatherCigarette" },
  { label: "Circle Arrow Left", value: "FeatherCircleArrowLeft" },
  { label: "Circle Arrow Right", value: "FeatherCircleArrowRight" },
  { label: "Circle Check Big", value: "FeatherCircleCheckBig" },
  { label: "Circle Check", value: "FeatherCircleCheck" },
  { label: "Circle Dashed", value: "FeatherCircleDashed" },
  { label: "Circle Dollar Sign", value: "FeatherCircleDollarSign" },
  { label: "Circle Dot Dashed", value: "FeatherCircleDotDashed" },
  { label: "Circle Dot", value: "FeatherCircleDot" },
  { label: "Circle Ellipsis", value: "FeatherCircleEllipsis" },
  { label: "Circle Equal", value: "FeatherCircleEqual" },
  { label: "Circle Fading Arrow Up", value: "FeatherCircleFadingArrowUp" },
  { label: "Circle Fading Plus", value: "FeatherCircleFadingPlus" },
  { label: "Circle Off", value: "FeatherCircleOff" },
  { label: "Circle Pound Sterling", value: "FeatherCirclePoundSterling" },
  { label: "Circle Power", value: "FeatherCirclePower" },
  { label: "Circle Slash 2", value: "FeatherCircleSlash2" },
  { label: "Circle Slash", value: "FeatherCircleSlash" },
  { label: "Circle Slashed", value: "FeatherCircleSlashed" },
  { label: "Circle Small", value: "FeatherCircleSmall" },
  { label: "Circle Stop", value: "FeatherCircleStop" },
  { label: "Circle", value: "FeatherCircle" },
  { label: "Circuit Board", value: "FeatherCircuitBoard" },
  { label: "Citrus", value: "FeatherCitrus" },
  { label: "Clapperboard", value: "FeatherClapperboard" },
  { label: "Clipboard Check", value: "FeatherClipboardCheck" },
  { label: "Clipboard Copy", value: "FeatherClipboardCopy" },
  { label: "Clipboard Edit", value: "FeatherClipboardEdit" },
  { label: "Clipboard List", value: "FeatherClipboardList" },
  { label: "Clipboard Minus", value: "FeatherClipboardMinus" },
  { label: "Clipboard Paste", value: "FeatherClipboardPaste" },
  { label: "Clipboard Pen Line", value: "FeatherClipboardPenLine" },
  { label: "Clipboard Pen", value: "FeatherClipboardPen" },
  { label: "Clipboard Plus", value: "FeatherClipboardPlus" },
  { label: "Clipboard Signature", value: "FeatherClipboardSignature" },
  { label: "Clipboard Type", value: "FeatherClipboardType" },
  { label: "Clipboard X", value: "FeatherClipboardX" },
  { label: "Clipboard", value: "FeatherClipboard" },
  { label: "Clock 1", value: "FeatherClock1" },
  { label: "Clock 10", value: "FeatherClock10" },
  { label: "Clock 11", value: "FeatherClock11" },
  { label: "Clock 12", value: "FeatherClock12" },
  { label: "Clock 2", value: "FeatherClock2" },
  { label: "Clock 3", value: "FeatherClock3" },
  { label: "Clock 4", value: "FeatherClock4" },
  { label: "Clock 5", value: "FeatherClock5" },
  { label: "Clock 6", value: "FeatherClock6" },
  { label: "Clock 7", value: "FeatherClock7" },
  { label: "Clock 8", value: "FeatherClock8" },
  { label: "Clock 9", value: "FeatherClock9" },
  { label: "Clock Alert", value: "FeatherClockAlert" },
  { label: "Clock Arrow Down", value: "FeatherClockArrowDown" },
  { label: "Clock Arrow Up", value: "FeatherClockArrowUp" },
  { label: "Clock Fading", value: "FeatherClockFading" },
  { label: "Clock Plus", value: "FeatherClockPlus" },
  { label: "Clock", value: "FeatherClock" },
  { label: "Cloud Alert", value: "FeatherCloudAlert" },
  { label: "Cloud Check", value: "FeatherCloudCheck" },
  { label: "Cloud Cog", value: "FeatherCloudCog" },
  { label: "Cloud Download", value: "FeatherCloudDownload" },
  { label: "Cloud Drizzle", value: "FeatherCloudDrizzle" },
  { label: "Cloud Fog", value: "FeatherCloudFog" },
  { label: "Cloud Hail", value: "FeatherCloudHail" },
  { label: "Cloud Lightning", value: "FeatherCloudLightning" },
  { label: "Cloud Moon Rain", value: "FeatherCloudMoonRain" },
  { label: "Cloud Moon", value: "FeatherCloudMoon" },
  { label: "Cloud Off", value: "FeatherCloudOff" },
  { label: "Cloud Rain Wind", value: "FeatherCloudRainWind" },
  { label: "Cloud Rain", value: "FeatherCloudRain" },
  { label: "Cloud Snow", value: "FeatherCloudSnow" },
  { label: "Cloud Sun Rain", value: "FeatherCloudSunRain" },
  { label: "Cloud Sun", value: "FeatherCloudSun" },
  { label: "Cloud Upload", value: "FeatherCloudUpload" },
  { label: "Cloud", value: "FeatherCloud" },
  { label: "Cloudy", value: "FeatherCloudy" },
  { label: "Clover", value: "FeatherClover" },
  { label: "Club", value: "FeatherClub" },
  { label: "Code 2", value: "FeatherCode2" },
  { label: "Code", value: "FeatherCode" },
  { label: "Codepen", value: "FeatherCodepen" },
  { label: "Codesandbox", value: "FeatherCodesandbox" },
  { label: "Coffee", value: "FeatherCoffee" },
  { label: "Cog", value: "FeatherCog" },
  { label: "Coins", value: "FeatherCoins" },
  { label: "Columns 2", value: "FeatherColumns2" },
  { label: "Columns 3 Cog", value: "FeatherColumns3Cog" },
  { label: "Columns 3", value: "FeatherColumns3" },
  { label: "Columns 4", value: "FeatherColumns4" },
  { label: "Columns", value: "FeatherColumns" },
  { label: "Combine", value: "FeatherCombine" },
  { label: "Command", value: "FeatherCommand" },
  { label: "Compass", value: "FeatherCompass" },
  { label: "Component", value: "FeatherComponent" },
  { label: "Computer", value: "FeatherComputer" },
  { label: "Concierge Bell", value: "FeatherConciergeBell" },
  { label: "Cone", value: "FeatherCone" },
  { label: "Construction", value: "FeatherConstruction" },
  { label: "Contact 2", value: "FeatherContact2" },
  { label: "Contact Round", value: "FeatherContactRound" },
  { label: "Contact", value: "FeatherContact" },
  { label: "Container", value: "FeatherContainer" },
  { label: "Contrast", value: "FeatherContrast" },
  { label: "Cookie", value: "FeatherCookie" },
  { label: "Cooking Pot", value: "FeatherCookingPot" },
  { label: "Copy Check", value: "FeatherCopyCheck" },
  { label: "Copy Minus", value: "FeatherCopyMinus" },
  { label: "Copy Plus", value: "FeatherCopyPlus" },
  { label: "Copy Slash", value: "FeatherCopySlash" },
  { label: "Copy X", value: "FeatherCopyX" },
  { label: "Copy", value: "FeatherCopy" },
  { label: "Copyleft", value: "FeatherCopyleft" },
  { label: "Copyright", value: "FeatherCopyright" },
  { label: "Corner Down Left", value: "FeatherCornerDownLeft" },
  { label: "Corner Down Right", value: "FeatherCornerDownRight" },
  { label: "Corner Full", value: "FeatherCornerFull" },
  { label: "Corner Large", value: "FeatherCornerLarge" },
  { label: "Corner Left Down", value: "FeatherCornerLeftDown" },
  { label: "Corner Left Up", value: "FeatherCornerLeftUp" },
  { label: "Corner Medium", value: "FeatherCornerMedium" },
  { label: "Corner Right Down", value: "FeatherCornerRightDown" },
  { label: "Corner Right Up", value: "FeatherCornerRightUp" },
  { label: "Corner Small", value: "FeatherCornerSmall" },
  { label: "Corner Up Left", value: "FeatherCornerUpLeft" },
  { label: "Corner Up Right", value: "FeatherCornerUpRight" },
  { label: "Cpu", value: "FeatherCpu" },
  { label: "Creative Commons", value: "FeatherCreativeCommons" },
  { label: "Credit Card", value: "FeatherCreditCard" },
  { label: "Croissant", value: "FeatherCroissant" },
  { label: "Crop", value: "FeatherCrop" },
  { label: "Cross", value: "FeatherCross" },
  { label: "Crosshair", value: "FeatherCrosshair" },
  { label: "Crown", value: "FeatherCrown" },
  { label: "Cuboid", value: "FeatherCuboid" },
  { label: "Cup Soda", value: "FeatherCupSoda" },
  { label: "Curly Braces", value: "FeatherCurlyBraces" },
  { label: "Currency", value: "FeatherCurrency" },
  { label: "Cylinder", value: "FeatherCylinder" },
  { label: "Dam", value: "FeatherDam" },
  { label: "Database Backup", value: "FeatherDatabaseBackup" },
  { label: "Database Zap", value: "FeatherDatabaseZap" },
  { label: "Database", value: "FeatherDatabase" },
  { label: "Decimals Arrow Left", value: "FeatherDecimalsArrowLeft" },
  { label: "Decimals Arrow Right", value: "FeatherDecimalsArrowRight" },
  { label: "Delete", value: "FeatherDelete" },
  { label: "Dessert", value: "FeatherDessert" },
  { label: "Diameter", value: "FeatherDiameter" },
  { label: "Diamond Minus", value: "FeatherDiamondMinus" },
  { label: "Diamond Plus", value: "FeatherDiamondPlus" },
  { label: "Diamond", value: "FeatherDiamond" },
  { label: "Dice 1", value: "FeatherDice1" },
  { label: "Dice 2", value: "FeatherDice2" },
  { label: "Dice 3", value: "FeatherDice3" },
  { label: "Dice 4", value: "FeatherDice4" },
  { label: "Dice 5", value: "FeatherDice5" },
  { label: "Dice 6", value: "FeatherDice6" },
  { label: "Dices", value: "FeatherDices" },
  { label: "Diff", value: "FeatherDiff" },
  { label: "Disc 2", value: "FeatherDisc2" },
  { label: "Disc 3", value: "FeatherDisc3" },
  { label: "Disc Album", value: "FeatherDiscAlbum" },
  { label: "Disc", value: "FeatherDisc" },
  { label: "Divide Circle", value: "FeatherDivideCircle" },
  { label: "Divide Square", value: "FeatherDivideSquare" },
  { label: "Divide", value: "FeatherDivide" },
  { label: "Dna Off", value: "FeatherDnaOff" },
  { label: "Dna", value: "FeatherDna" },
  { label: "Dock", value: "FeatherDock" },
  { label: "Dog", value: "FeatherDog" },
  { label: "Dollar Sign", value: "FeatherDollarSign" },
  { label: "Donut", value: "FeatherDonut" },
  { label: "Door Closed Locked", value: "FeatherDoorClosedLocked" },
  { label: "Door Closed", value: "FeatherDoorClosed" },
  { label: "Door Open", value: "FeatherDoorOpen" },
  { label: "Dot", value: "FeatherDot" },
  { label: "Download Cloud", value: "FeatherDownloadCloud" },
  { label: "Download", value: "FeatherDownload" },
  { label: "Drafting Compass", value: "FeatherDraftingCompass" },
  { label: "Drama", value: "FeatherDrama" },
  { label: "Dribbble", value: "FeatherDribbble" },
  { label: "Drill", value: "FeatherDrill" },
  { label: "Drone", value: "FeatherDrone" },
  { label: "Droplet Off", value: "FeatherDropletOff" },
  { label: "Droplet", value: "FeatherDroplet" },
  { label: "Droplets", value: "FeatherDroplets" },
  { label: "Drum", value: "FeatherDrum" },
  { label: "Drumstick", value: "FeatherDrumstick" },
  { label: "Dumbbell", value: "FeatherDumbbell" },
  { label: "Ear Off", value: "FeatherEarOff" },
  { label: "Ear", value: "FeatherEar" },
  { label: "Earth Lock", value: "FeatherEarthLock" },
  { label: "Earth", value: "FeatherEarth" },
  { label: "Eclipse", value: "FeatherEclipse" },
  { label: "Edit 2", value: "FeatherEdit2" },
  { label: "Edit 3", value: "FeatherEdit3" },
  { label: "Edit", value: "FeatherEdit" },
  { label: "Egg Fried", value: "FeatherEggFried" },
  { label: "Egg Off", value: "FeatherEggOff" },
  { label: "Egg", value: "FeatherEgg" },
  { label: "Equal Approximately", value: "FeatherEqualApproximately" },
  { label: "Equal Not", value: "FeatherEqualNot" },
  { label: "Equal", value: "FeatherEqual" },
  { label: "Eraser", value: "FeatherEraser" },
  { label: "Ethernet Port", value: "FeatherEthernetPort" },
  { label: "Euro", value: "FeatherEuro" },
  { label: "Expand", value: "FeatherExpand" },
  { label: "External Link", value: "FeatherExternalLink" },
  { label: "Eye Closed", value: "FeatherEyeClosed" },
  { label: "Eye Off", value: "FeatherEyeOff" },
  { label: "Eye", value: "FeatherEye" },
  { label: "Facebook", value: "FeatherFacebook" },
  { label: "Factory", value: "FeatherFactory" },
  { label: "Fan", value: "FeatherFan" },
  { label: "Fast Forward", value: "FeatherFastForward" },
  { label: "Feather", value: "FeatherFeather" },
  { label: "Fence", value: "FeatherFence" },
  { label: "Ferris Wheel", value: "FeatherFerrisWheel" },
  { label: "Figma", value: "FeatherFigma" },
  { label: "File Archive", value: "FeatherFileArchive" },
  { label: "File Audio 2", value: "FeatherFileAudio2" },
  { label: "File Audio", value: "FeatherFileAudio" },
  { label: "File Axis 3d", value: "FeatherFileAxis3D" },
  { label: "File Badge 2", value: "FeatherFileBadge2" },
  { label: "File Badge", value: "FeatherFileBadge" },
  { label: "File Bar Chart 2", value: "FeatherFileBarChart2" },
  { label: "File Bar Chart", value: "FeatherFileBarChart" },
  { label: "File Box", value: "FeatherFileBox" },
  {
    label: "File Chart Column Increasing",
    value: "FeatherFileChartColumnIncreasing",
  },
  { label: "File Chart Column", value: "FeatherFileChartColumn" },
  { label: "File Chart Line", value: "FeatherFileChartLine" },
  { label: "File Chart Pie", value: "FeatherFileChartPie" },
  { label: "File Check 2", value: "FeatherFileCheck2" },
  { label: "File Check", value: "FeatherFileCheck" },
  { label: "File Clock", value: "FeatherFileClock" },
  { label: "File Code 2", value: "FeatherFileCode2" },
  { label: "File Code", value: "FeatherFileCode" },
  { label: "File Cog 2", value: "FeatherFileCog2" },
  { label: "File Cog", value: "FeatherFileCog" },
  { label: "File Diff", value: "FeatherFileDiff" },
  { label: "File Digit", value: "FeatherFileDigit" },
  { label: "File Down", value: "FeatherFileDown" },
  { label: "File Edit", value: "FeatherFileEdit" },
  { label: "File Heart", value: "FeatherFileHeart" },
  { label: "File Image", value: "FeatherFileImage" },
  { label: "File Input", value: "FeatherFileInput" },
  { label: "File Json 2", value: "FeatherFileJson2" },
  { label: "File Json", value: "FeatherFileJson" },
  { label: "File Key 2", value: "FeatherFileKey2" },
  { label: "File Key", value: "FeatherFileKey" },
  { label: "File Line Chart", value: "FeatherFileLineChart" },
  { label: "File Lock 2", value: "FeatherFileLock2" },
  { label: "File Lock", value: "FeatherFileLock" },
  { label: "File Minus 2", value: "FeatherFileMinus2" },
  { label: "File Minus", value: "FeatherFileMinus" },
  { label: "File Music", value: "FeatherFileMusic" },
  { label: "File Output", value: "FeatherFileOutput" },
  { label: "File Pen Line", value: "FeatherFilePenLine" },
  { label: "File Pen", value: "FeatherFilePen" },
  { label: "File Pie Chart", value: "FeatherFilePieChart" },
  { label: "File Plus 2", value: "FeatherFilePlus2" },
  { label: "File Plus", value: "FeatherFilePlus" },
  { label: "File Question Mark", value: "FeatherFileQuestionMark" },
  { label: "File Question", value: "FeatherFileQuestion" },
  { label: "File Scan", value: "FeatherFileScan" },
  { label: "File Search 2", value: "FeatherFileSearch2" },
  { label: "File Search", value: "FeatherFileSearch" },
  { label: "File Signature", value: "FeatherFileSignature" },
  { label: "File Sliders", value: "FeatherFileSliders" },
  { label: "File Spreadsheet", value: "FeatherFileSpreadsheet" },
  { label: "File Stack", value: "FeatherFileStack" },
  { label: "File Symlink", value: "FeatherFileSymlink" },
  { label: "File Terminal", value: "FeatherFileTerminal" },
  { label: "File Text", value: "FeatherFileText" },
  { label: "File Type 2", value: "FeatherFileType2" },
  { label: "File Type", value: "FeatherFileType" },
  { label: "File Up", value: "FeatherFileUp" },
  { label: "File User", value: "FeatherFileUser" },
  { label: "File Video 2", value: "FeatherFileVideo2" },
  { label: "File Video", value: "FeatherFileVideo" },
  { label: "File Volume 2", value: "FeatherFileVolume2" },
  { label: "File Volume", value: "FeatherFileVolume" },
  { label: "File Warning", value: "FeatherFileWarning" },
  { label: "File X 2", value: "FeatherFileX2" },
  { label: "File X", value: "FeatherFileX" },
  { label: "File", value: "FeatherFile" },
  { label: "Files", value: "FeatherFiles" },
  { label: "Film", value: "FeatherFilm" },
  { label: "Filter X", value: "FeatherFilterX" },
  { label: "Filter", value: "FeatherFilter" },
  { label: "Fingerprint", value: "FeatherFingerprint" },
  { label: "Fire Extinguisher", value: "FeatherFireExtinguisher" },
  { label: "Fish Off", value: "FeatherFishOff" },
  { label: "Fish Symbol", value: "FeatherFishSymbol" },
  { label: "Fish", value: "FeatherFish" },
  { label: "Flag Off", value: "FeatherFlagOff" },
  { label: "Flag Triangle Left", value: "FeatherFlagTriangleLeft" },
  { label: "Flag Triangle Right", value: "FeatherFlagTriangleRight" },
  { label: "Flag", value: "FeatherFlag" },
  { label: "Flame Kindling", value: "FeatherFlameKindling" },
  { label: "Flame", value: "FeatherFlame" },
  { label: "Flashlight Off", value: "FeatherFlashlightOff" },
  { label: "Flashlight", value: "FeatherFlashlight" },
  { label: "Flask Conical Off", value: "FeatherFlaskConicalOff" },
  { label: "Flask Conical", value: "FeatherFlaskConical" },
  { label: "Flask Round", value: "FeatherFlaskRound" },
  { label: "Flip Horizontal 2", value: "FeatherFlipHorizontal2" },
  { label: "Flip Horizontal", value: "FeatherFlipHorizontal" },
  { label: "Flip Vertical 2", value: "FeatherFlipVertical2" },
  { label: "Flip Vertical", value: "FeatherFlipVertical" },
  { label: "Flower 2", value: "FeatherFlower2" },
  { label: "Flower", value: "FeatherFlower" },
  { label: "Focus", value: "FeatherFocus" },
  { label: "Fold Horizontal", value: "FeatherFoldHorizontal" },
  { label: "Fold Vertical", value: "FeatherFoldVertical" },
  { label: "Folder Archive", value: "FeatherFolderArchive" },
  { label: "Folder Check", value: "FeatherFolderCheck" },
  { label: "Folder Clock", value: "FeatherFolderClock" },
  { label: "Folder Closed", value: "FeatherFolderClosed" },
  { label: "Folder Code", value: "FeatherFolderCode" },
  { label: "Folder Cog 2", value: "FeatherFolderCog2" },
  { label: "Folder Cog", value: "FeatherFolderCog" },
  { label: "Folder Dot", value: "FeatherFolderDot" },
  { label: "Folder Down", value: "FeatherFolderDown" },
  { label: "Folder Edit", value: "FeatherFolderEdit" },
  { label: "Folder Git 2", value: "FeatherFolderGit2" },
  { label: "Folder Git", value: "FeatherFolderGit" },
  { label: "Folder Heart", value: "FeatherFolderHeart" },
  { label: "Folder Input", value: "FeatherFolderInput" },
  { label: "Folder Kanban", value: "FeatherFolderKanban" },
  { label: "Folder Key", value: "FeatherFolderKey" },
  { label: "Folder Lock", value: "FeatherFolderLock" },
  { label: "Folder Minus", value: "FeatherFolderMinus" },
  { label: "Folder Open Dot", value: "FeatherFolderOpenDot" },
  { label: "Folder Open", value: "FeatherFolderOpen" },
  { label: "Folder Output", value: "FeatherFolderOutput" },
  { label: "Folder Pen", value: "FeatherFolderPen" },
  { label: "Folder Plus", value: "FeatherFolderPlus" },
  { label: "Folder Root", value: "FeatherFolderRoot" },
  { label: "Folder Search 2", value: "FeatherFolderSearch2" },
  { label: "Folder Search", value: "FeatherFolderSearch" },
  { label: "Folder Symlink", value: "FeatherFolderSymlink" },
  { label: "Folder Sync", value: "FeatherFolderSync" },
  { label: "Folder Tree", value: "FeatherFolderTree" },
  { label: "Folder Up", value: "FeatherFolderUp" },
  { label: "Folder X", value: "FeatherFolderX" },
  { label: "Folder", value: "FeatherFolder" },
  { label: "Folders", value: "FeatherFolders" },
  { label: "Footprints", value: "FeatherFootprints" },
  { label: "Forklift", value: "FeatherForklift" },
  { label: "Form Input", value: "FeatherFormInput" },
  { label: "Forward", value: "FeatherForward" },
  { label: "Frame", value: "FeatherFrame" },
  { label: "Framer", value: "FeatherFramer" },
  { label: "Frown", value: "FeatherFrown" },
  { label: "Fuel", value: "FeatherFuel" },
  { label: "Fullscreen", value: "FeatherFullscreen" },
  { label: "Function Square", value: "FeatherFunctionSquare" },
  { label: "Funnel Plus", value: "FeatherFunnelPlus" },
  { label: "Funnel X", value: "FeatherFunnelX" },
  { label: "Funnel", value: "FeatherFunnel" },
  { label: "Gallery Horizontal End", value: "FeatherGalleryHorizontalEnd" },
  { label: "Gallery Horizontal", value: "FeatherGalleryHorizontal" },
  { label: "Gallery Thumbnails", value: "FeatherGalleryThumbnails" },
  { label: "Gallery Vertical End", value: "FeatherGalleryVerticalEnd" },
  { label: "Gallery Vertical", value: "FeatherGalleryVertical" },
  { label: "Gamepad 2", value: "FeatherGamepad2" },
  { label: "Gamepad", value: "FeatherGamepad" },
  { label: "Gantt Chart Square", value: "FeatherGanttChartSquare" },
  { label: "Gantt Chart", value: "FeatherGanttChart" },
  { label: "Gauge Circle", value: "FeatherGaugeCircle" },
  { label: "Gauge", value: "FeatherGauge" },
  { label: "Gavel", value: "FeatherGavel" },
  { label: "Gem", value: "FeatherGem" },
  { label: "Georgian Lari", value: "FeatherGeorgianLari" },
  { label: "Ghost", value: "FeatherGhost" },
  { label: "Gift", value: "FeatherGift" },
  { label: "Git Branch Plus", value: "FeatherGitBranchPlus" },
  { label: "Git Branch", value: "FeatherGitBranch" },
  { label: "Git Commit Horizontal", value: "FeatherGitCommitHorizontal" },
  { label: "Git Commit Vertical", value: "FeatherGitCommitVertical" },
  { label: "Git Commit", value: "FeatherGitCommit" },
  { label: "Git Compare Arrows", value: "FeatherGitCompareArrows" },
  { label: "Git Compare", value: "FeatherGitCompare" },
  { label: "Git Fork", value: "FeatherGitFork" },
  { label: "Git Graph", value: "FeatherGitGraph" },
  { label: "Git Merge", value: "FeatherGitMerge" },
  { label: "Git Pull Request Arrow", value: "FeatherGitPullRequestArrow" },
  { label: "Git Pull Request Closed", value: "FeatherGitPullRequestClosed" },
  {
    label: "Git Pull Request Create Arrow",
    value: "FeatherGitPullRequestCreateArrow",
  },
  { label: "Git Pull Request Create", value: "FeatherGitPullRequestCreate" },
  { label: "Git Pull Request Draft", value: "FeatherGitPullRequestDraft" },
  { label: "Git Pull Request", value: "FeatherGitPullRequest" },
  { label: "Github", value: "FeatherGithub" },
  { label: "Gitlab", value: "FeatherGitlab" },
  { label: "Glass Water", value: "FeatherGlassWater" },
  { label: "Glasses", value: "FeatherGlasses" },
  { label: "Globe 2", value: "FeatherGlobe2" },
  { label: "Globe Lock", value: "FeatherGlobeLock" },
  { label: "Globe", value: "FeatherGlobe" },
  { label: "Goal", value: "FeatherGoal" },
  { label: "Gpu", value: "FeatherGpu" },
  { label: "Grab", value: "FeatherGrab" },
  { label: "Graduation Cap", value: "FeatherGraduationCap" },
  { label: "Grape", value: "FeatherGrape" },
  { label: "Grid 2x2 Check", value: "FeatherGrid2X2Check" },
  { label: "Grid 2x2 Plus", value: "FeatherGrid2X2Plus" },
  { label: "Grid 2x2 X", value: "FeatherGrid2X2X" },
  { label: "Grid 2x2", value: "FeatherGrid2X2" },
  { label: "Grid 3x2", value: "FeatherGrid3X2" },
  { label: "Grid 3x3", value: "FeatherGrid3X3" },
  { label: "Grid", value: "FeatherGrid" },
  { label: "Grip Horizontal", value: "FeatherGripHorizontal" },
  { label: "Grip Vertical", value: "FeatherGripVertical" },
  { label: "Grip", value: "FeatherGrip" },
  { label: "Group", value: "FeatherGroup" },
  { label: "Guitar", value: "FeatherGuitar" },
  { label: "Ham", value: "FeatherHam" },
  { label: "Hamburger", value: "FeatherHamburger" },
  { label: "Hammer", value: "FeatherHammer" },
  { label: "Hand Coins", value: "FeatherHandCoins" },
  { label: "Hand Heart", value: "FeatherHandHeart" },
  { label: "Hand Helping", value: "FeatherHandHelping" },
  { label: "Hand Metal", value: "FeatherHandMetal" },
  { label: "Hand Platter", value: "FeatherHandPlatter" },
  { label: "Hand", value: "FeatherHand" },
  { label: "Handshake", value: "FeatherHandshake" },
  { label: "Hard Drive Download", value: "FeatherHardDriveDownload" },
  { label: "Hard Drive Upload", value: "FeatherHardDriveUpload" },
  { label: "Hard Drive", value: "FeatherHardDrive" },
  { label: "Hard Hat", value: "FeatherHardHat" },
  { label: "Hash", value: "FeatherHash" },
  { label: "Haze", value: "FeatherHaze" },
  { label: "Hdmi Port", value: "FeatherHdmiPort" },
  { label: "Heading 1", value: "FeatherHeading1" },
  { label: "Heading 2", value: "FeatherHeading2" },
  { label: "Heading 3", value: "FeatherHeading3" },
  { label: "Heading 4", value: "FeatherHeading4" },
  { label: "Heading 5", value: "FeatherHeading5" },
  { label: "Heading 6", value: "FeatherHeading6" },
  { label: "Heading", value: "FeatherHeading" },
  { label: "Headphone Off", value: "FeatherHeadphoneOff" },
  { label: "Headphones", value: "FeatherHeadphones" },
  { label: "Headset", value: "FeatherHeadset" },
  { label: "Heart Crack", value: "FeatherHeartCrack" },
  { label: "Heart Handshake", value: "FeatherHeartHandshake" },
  { label: "Heart Minus", value: "FeatherHeartMinus" },
  { label: "Heart Off", value: "FeatherHeartOff" },
  { label: "Heart Plus", value: "FeatherHeartPlus" },
  { label: "Heart Pulse", value: "FeatherHeartPulse" },
  { label: "Heart", value: "FeatherHeart" },
  { label: "Heater", value: "FeatherHeater" },
  { label: "Help Circle", value: "FeatherHelpCircle" },
  { label: "Helping Hand", value: "FeatherHelpingHand" },
  { label: "Hexagon", value: "FeatherHexagon" },
  { label: "Highlighter", value: "FeatherHighlighter" },
  { label: "History", value: "FeatherHistory" },
  { label: "Home", value: "FeatherHome" },
  { label: "Hop Off", value: "FeatherHopOff" },
  { label: "Hop", value: "FeatherHop" },
  { label: "Hospital", value: "FeatherHospital" },
  { label: "Hotel", value: "FeatherHotel" },
  { label: "Hourglass", value: "FeatherHourglass" },
  { label: "House Plug", value: "FeatherHousePlug" },
  { label: "House Plus", value: "FeatherHousePlus" },
  { label: "House Wifi", value: "FeatherHouseWifi" },
  { label: "House", value: "FeatherHouse" },
  { label: "Ice Cream 2", value: "FeatherIceCream2" },
  { label: "Ice Cream Bowl", value: "FeatherIceCreamBowl" },
  { label: "Ice Cream", value: "FeatherIceCream" },
  { label: "Id Card Lanyard", value: "FeatherIdCardLanyard" },
  { label: "Id Card", value: "FeatherIdCard" },
  { label: "Image Down", value: "FeatherImageDown" },
  { label: "Image Minus", value: "FeatherImageMinus" },
  { label: "Image Off", value: "FeatherImageOff" },
  { label: "Image Play", value: "FeatherImagePlay" },
  { label: "Image Plus", value: "FeatherImagePlus" },
  { label: "Image Up", value: "FeatherImageUp" },
  { label: "Image Upscale", value: "FeatherImageUpscale" },
  { label: "Image", value: "FeatherImage" },
  { label: "Images", value: "FeatherImages" },
  { label: "Import", value: "FeatherImport" },
  { label: "Inbox", value: "FeatherInbox" },
  { label: "Indent Decrease", value: "FeatherIndentDecrease" },
  { label: "Indent Increase", value: "FeatherIndentIncrease" },
  { label: "Indent", value: "FeatherIndent" },
  { label: "Indian Rupee", value: "FeatherIndianRupee" },
  { label: "Infinity", value: "FeatherInfinity" },
  { label: "Info", value: "FeatherInfo" },
  { label: "Inspect", value: "FeatherInspect" },
  { label: "Inspection Panel", value: "FeatherInspectionPanel" },
  { label: "Instagram", value: "FeatherInstagram" },
  { label: "Italic", value: "FeatherItalic" },
  { label: "Iteration Ccw", value: "FeatherIterationCcw" },
  { label: "Iteration Cw", value: "FeatherIterationCw" },
  { label: "Japanese Yen", value: "FeatherJapaneseYen" },
  { label: "Joystick", value: "FeatherJoystick" },
  { label: "Kanban Square Dashed", value: "FeatherKanbanSquareDashed" },
  { label: "Kanban Square", value: "FeatherKanbanSquare" },
  { label: "Kanban", value: "FeatherKanban" },
  { label: "Key Round", value: "FeatherKeyRound" },
  { label: "Key Square", value: "FeatherKeySquare" },
  { label: "Key", value: "FeatherKey" },
  { label: "Keyboard Music", value: "FeatherKeyboardMusic" },
  { label: "Keyboard Off", value: "FeatherKeyboardOff" },
  { label: "Keyboard", value: "FeatherKeyboard" },
  { label: "Lamp Ceiling", value: "FeatherLampCeiling" },
  { label: "Lamp Desk", value: "FeatherLampDesk" },
  { label: "Lamp Floor", value: "FeatherLampFloor" },
  { label: "Lamp Wall Down", value: "FeatherLampWallDown" },
  { label: "Lamp Wall Up", value: "FeatherLampWallUp" },
  { label: "Lamp", value: "FeatherLamp" },
  { label: "Land Plot", value: "FeatherLandPlot" },
  { label: "Landmark", value: "FeatherLandmark" },
  { label: "Languages", value: "FeatherLanguages" },
  { label: "Laptop 2", value: "FeatherLaptop2" },
  { label: "Laptop Minimal Check", value: "FeatherLaptopMinimalCheck" },
  { label: "Laptop", value: "FeatherLaptop" },
  { label: "Lasso Select", value: "FeatherLassoSelect" },
  { label: "Lasso", value: "FeatherLasso" },
  { label: "Laugh", value: "FeatherLaugh" },
  { label: "Layers 2", value: "FeatherLayers2" },
  { label: "Layers 3", value: "FeatherLayers3" },
  { label: "Layers", value: "FeatherLayers" },
  { label: "Layout Dashboard", value: "FeatherLayoutDashboard" },
  { label: "Layout Grid", value: "FeatherLayoutGrid" },
  { label: "Layout List", value: "FeatherLayoutList" },
  { label: "Layout Panel Left", value: "FeatherLayoutPanelLeft" },
  { label: "Layout Panel Top", value: "FeatherLayoutPanelTop" },
  { label: "Layout Template", value: "FeatherLayoutTemplate" },
  { label: "Layout", value: "FeatherLayout" },
  { label: "Leaf", value: "FeatherLeaf" },
  { label: "Leafy Green", value: "FeatherLeafyGreen" },
  { label: "Lectern", value: "FeatherLectern" },
  { label: "Letter Spacing", value: "FeatherLetterSpacing" },
  { label: "Letter Text", value: "FeatherLetterText" },
  { label: "Library Big", value: "FeatherLibraryBig" },
  { label: "Library Square", value: "FeatherLibrarySquare" },
  { label: "Library", value: "FeatherLibrary" },
  { label: "Life Buoy", value: "FeatherLifeBuoy" },
  { label: "Ligature", value: "FeatherLigature" },
  { label: "Lightbulb Off", value: "FeatherLightbulbOff" },
  { label: "Lightbulb", value: "FeatherLightbulb" },
  { label: "Line Chart", value: "FeatherLineChart" },
  { label: "Line Height", value: "FeatherLineHeight" },
  { label: "Line Squiggle", value: "FeatherLineSquiggle" },
  { label: "Link 2 Off", value: "FeatherLink2Off" },
  { label: "Link 2", value: "FeatherLink2" },
  { label: "Link", value: "FeatherLink" },
  { label: "Linkedin", value: "FeatherLinkedin" },
  { label: "List Check", value: "FeatherListCheck" },
  { label: "List Checks", value: "FeatherListChecks" },
  { label: "List Collapse", value: "FeatherListCollapse" },
  { label: "List End", value: "FeatherListEnd" },
  { label: "List Filter Plus", value: "FeatherListFilterPlus" },
  { label: "List Filter", value: "FeatherListFilter" },
  { label: "List Minus", value: "FeatherListMinus" },
  { label: "List Music", value: "FeatherListMusic" },
  { label: "List Ordered", value: "FeatherListOrdered" },
  { label: "List Plus", value: "FeatherListPlus" },
  { label: "List Restart", value: "FeatherListRestart" },
  { label: "List Start", value: "FeatherListStart" },
  { label: "List Todo", value: "FeatherListTodo" },
  { label: "List Tree", value: "FeatherListTree" },
  { label: "List Video", value: "FeatherListVideo" },
  { label: "List X", value: "FeatherListX" },
  { label: "List", value: "FeatherList" },
  { label: "Loader 2", value: "FeatherLoader2" },
  { label: "Loader Pinwheel", value: "FeatherLoaderPinwheel" },
  { label: "Loader", value: "FeatherLoader" },
  { label: "Locate Fixed", value: "FeatherLocateFixed" },
  { label: "Locate Off", value: "FeatherLocateOff" },
  { label: "Locate", value: "FeatherLocate" },
  { label: "Location Edit", value: "FeatherLocationEdit" },
  { label: "Lock Keyhole Open", value: "FeatherLockKeyholeOpen" },
  { label: "Lock Keyhole", value: "FeatherLockKeyhole" },
  { label: "Lock", value: "FeatherLock" },
  { label: "Log In", value: "FeatherLogIn" },
  { label: "Log Out", value: "FeatherLogOut" },
  { label: "Logs", value: "FeatherLogs" },
  { label: "Lollipop", value: "FeatherLollipop" },
  { label: "Luggage", value: "FeatherLuggage" },
  { label: "M Square", value: "FeatherMSquare" },
  { label: "Magnet", value: "FeatherMagnet" },
  { label: "Mail Check", value: "FeatherMailCheck" },
  { label: "Mail Minus", value: "FeatherMailMinus" },
  { label: "Mail Open", value: "FeatherMailOpen" },
  { label: "Mail Plus", value: "FeatherMailPlus" },
  { label: "Mail Question", value: "FeatherMailQuestion" },
  { label: "Mail Search", value: "FeatherMailSearch" },
  { label: "Mail Warning", value: "FeatherMailWarning" },
  { label: "Mail X", value: "FeatherMailX" },
  { label: "Mail", value: "FeatherMail" },
  { label: "Mailbox", value: "FeatherMailbox" },
  { label: "Mails", value: "FeatherMails" },
  { label: "Map Pin Check Inside", value: "FeatherMapPinCheckInside" },
  { label: "Map Pin Check", value: "FeatherMapPinCheck" },
  { label: "Map Pin House", value: "FeatherMapPinHouse" },
  { label: "Map Pin Minus Inside", value: "FeatherMapPinMinusInside" },
  { label: "Map Pin Minus", value: "FeatherMapPinMinus" },
  { label: "Map Pin Off", value: "FeatherMapPinOff" },
  { label: "Map Pin Plus Inside", value: "FeatherMapPinPlusInside" },
  { label: "Map Pin Plus", value: "FeatherMapPinPlus" },
  { label: "Map Pin X Inside", value: "FeatherMapPinXInside" },
  { label: "Map Pin X", value: "FeatherMapPinX" },
  { label: "Map Pin", value: "FeatherMapPin" },
  { label: "Map Pinned", value: "FeatherMapPinned" },
  { label: "Map Plus", value: "FeatherMapPlus" },
  { label: "Map", value: "FeatherMap" },
  { label: "Mars Stroke", value: "FeatherMarsStroke" },
  { label: "Mars", value: "FeatherMars" },
  { label: "Martini", value: "FeatherMartini" },
  { label: "Maximize 2", value: "FeatherMaximize2" },
  { label: "Maximize", value: "FeatherMaximize" },
  { label: "Medal", value: "FeatherMedal" },
  { label: "Megaphone Off", value: "FeatherMegaphoneOff" },
  { label: "Megaphone", value: "FeatherMegaphone" },
  { label: "Meh", value: "FeatherMeh" },
  { label: "Memory Stick", value: "FeatherMemoryStick" },
  { label: "Menu Square", value: "FeatherMenuSquare" },
  { label: "Menu", value: "FeatherMenu" },
  { label: "Merge", value: "FeatherMerge" },
  { label: "Message Circle Code", value: "FeatherMessageCircleCode" },
  { label: "Message Circle Dashed", value: "FeatherMessageCircleDashed" },
  { label: "Message Circle Heart", value: "FeatherMessageCircleHeart" },
  { label: "Message Circle More", value: "FeatherMessageCircleMore" },
  { label: "Message Circle Off", value: "FeatherMessageCircleOff" },
  { label: "Message Circle Plus", value: "FeatherMessageCirclePlus" },
  {
    label: "Message Circle Question Mark",
    value: "FeatherMessageCircleQuestionMark",
  },
  { label: "Message Circle Reply", value: "FeatherMessageCircleReply" },
  { label: "Message Circle Warning", value: "FeatherMessageCircleWarning" },
  { label: "Message Circle X", value: "FeatherMessageCircleX" },
  { label: "Message Circle", value: "FeatherMessageCircle" },
  { label: "Message Square Code", value: "FeatherMessageSquareCode" },
  { label: "Message Square Dashed", value: "FeatherMessageSquareDashed" },
  { label: "Message Square Diff", value: "FeatherMessageSquareDiff" },
  { label: "Message Square Dot", value: "FeatherMessageSquareDot" },
  { label: "Message Square Heart", value: "FeatherMessageSquareHeart" },
  { label: "Message Square Lock", value: "FeatherMessageSquareLock" },
  { label: "Message Square More", value: "FeatherMessageSquareMore" },
  { label: "Message Square Off", value: "FeatherMessageSquareOff" },
  { label: "Message Square Plus", value: "FeatherMessageSquarePlus" },
  { label: "Message Square Quote", value: "FeatherMessageSquareQuote" },
  { label: "Message Square Reply", value: "FeatherMessageSquareReply" },
  { label: "Message Square Share", value: "FeatherMessageSquareShare" },
  { label: "Message Square Text", value: "FeatherMessageSquareText" },
  { label: "Message Square Warning", value: "FeatherMessageSquareWarning" },
  { label: "Message Square X", value: "FeatherMessageSquareX" },
  { label: "Message Square", value: "FeatherMessageSquare" },
  { label: "Messages Square", value: "FeatherMessagesSquare" },
  { label: "Mic 2", value: "FeatherMic2" },
  { label: "Mic Off", value: "FeatherMicOff" },
  { label: "Mic Vocal", value: "FeatherMicVocal" },
  { label: "Mic", value: "FeatherMic" },
  { label: "Microchip", value: "FeatherMicrochip" },
  { label: "Microscope", value: "FeatherMicroscope" },
  { label: "Microwave", value: "FeatherMicrowave" },
  { label: "Milestone", value: "FeatherMilestone" },
  { label: "Milk Off", value: "FeatherMilkOff" },
  { label: "Milk", value: "FeatherMilk" },
  { label: "Minimize 2", value: "FeatherMinimize2" },
  { label: "Minimize", value: "FeatherMinimize" },
  { label: "Minus Circle", value: "FeatherMinusCircle" },
  { label: "Minus Square", value: "FeatherMinusSquare" },
  { label: "Minus", value: "FeatherMinus" },
  { label: "Monitor Check", value: "FeatherMonitorCheck" },
  { label: "Monitor Cog", value: "FeatherMonitorCog" },
  { label: "Monitor Dot", value: "FeatherMonitorDot" },
  { label: "Monitor Down", value: "FeatherMonitorDown" },
  { label: "Monitor Off", value: "FeatherMonitorOff" },
  { label: "Monitor Pause", value: "FeatherMonitorPause" },
  { label: "Monitor Play", value: "FeatherMonitorPlay" },
  { label: "Monitor Smartphone", value: "FeatherMonitorSmartphone" },
  { label: "Monitor Speaker", value: "FeatherMonitorSpeaker" },
  { label: "Monitor Stop", value: "FeatherMonitorStop" },
  { label: "Monitor Up", value: "FeatherMonitorUp" },
  { label: "Monitor X", value: "FeatherMonitorX" },
  { label: "Monitor", value: "FeatherMonitor" },
  { label: "Moon Star", value: "FeatherMoonStar" },
  { label: "Moon", value: "FeatherMoon" },
  { label: "More Horizontal", value: "FeatherMoreHorizontal" },
  { label: "More Vertical", value: "FeatherMoreVertical" },
  { label: "Mountain Snow", value: "FeatherMountainSnow" },
  { label: "Mountain", value: "FeatherMountain" },
  { label: "Mouse Off", value: "FeatherMouseOff" },
  { label: "Mouse Pointer 2", value: "FeatherMousePointer2" },
  { label: "Mouse Pointer Ban", value: "FeatherMousePointerBan" },
  { label: "Mouse Pointer Click", value: "FeatherMousePointerClick" },
  {
    label: "Mouse Pointer Square Dashed",
    value: "FeatherMousePointerSquareDashed",
  },
  { label: "Mouse Pointer Square", value: "FeatherMousePointerSquare" },
  { label: "Mouse Pointer", value: "FeatherMousePointer" },
  { label: "Mouse", value: "FeatherMouse" },
  { label: "Move 3d", value: "FeatherMove3D" },
  { label: "Move Diagonal 2", value: "FeatherMoveDiagonal2" },
  { label: "Move Diagonal", value: "FeatherMoveDiagonal" },
  { label: "Move Down Left", value: "FeatherMoveDownLeft" },
  { label: "Move Down Right", value: "FeatherMoveDownRight" },
  { label: "Move Down", value: "FeatherMoveDown" },
  { label: "Move Horizontal", value: "FeatherMoveHorizontal" },
  { label: "Move Left", value: "FeatherMoveLeft" },
  { label: "Move Right", value: "FeatherMoveRight" },
  { label: "Move Up Left", value: "FeatherMoveUpLeft" },
  { label: "Move Up Right", value: "FeatherMoveUpRight" },
  { label: "Move Up", value: "FeatherMoveUp" },
  { label: "Move Vertical", value: "FeatherMoveVertical" },
  { label: "Move", value: "FeatherMove" },
  { label: "Music 2", value: "FeatherMusic2" },
  { label: "Music 3", value: "FeatherMusic3" },
  { label: "Music 4", value: "FeatherMusic4" },
  { label: "Music", value: "FeatherMusic" },
  { label: "Navigation 2 Off", value: "FeatherNavigation2Off" },
  { label: "Navigation 2", value: "FeatherNavigation2" },
  { label: "Navigation Off", value: "FeatherNavigationOff" },
  { label: "Navigation", value: "FeatherNavigation" },
  { label: "Network", value: "FeatherNetwork" },
  { label: "Newspaper", value: "FeatherNewspaper" },
  { label: "Nfc", value: "FeatherNfc" },
  { label: "Non Binary", value: "FeatherNonBinary" },
  { label: "Notebook Pen", value: "FeatherNotebookPen" },
  { label: "Notebook Tabs", value: "FeatherNotebookTabs" },
  { label: "Notebook Text", value: "FeatherNotebookText" },
  { label: "Notebook", value: "FeatherNotebook" },
  { label: "Notepad Text Dashed", value: "FeatherNotepadTextDashed" },
  { label: "Notepad Text", value: "FeatherNotepadText" },
  { label: "Nut Off", value: "FeatherNutOff" },
  { label: "Nut", value: "FeatherNut" },
  { label: "Octagon Alert", value: "FeatherOctagonAlert" },
  { label: "Octagon Minus", value: "FeatherOctagonMinus" },
  { label: "Octagon Pause", value: "FeatherOctagonPause" },
  { label: "Octagon X", value: "FeatherOctagonX" },
  { label: "Octagon", value: "FeatherOctagon" },
  { label: "Omega", value: "FeatherOmega" },
  { label: "Option", value: "FeatherOption" },
  { label: "Orbit", value: "FeatherOrbit" },
  { label: "Origami", value: "FeatherOrigami" },
  { label: "Outdent", value: "FeatherOutdent" },
  { label: "Package 2", value: "FeatherPackage2" },
  { label: "Package Check", value: "FeatherPackageCheck" },
  { label: "Package Minus", value: "FeatherPackageMinus" },
  { label: "Package Open", value: "FeatherPackageOpen" },
  { label: "Package Plus", value: "FeatherPackagePlus" },
  { label: "Package Search", value: "FeatherPackageSearch" },
  { label: "Package X", value: "FeatherPackageX" },
  { label: "Package", value: "FeatherPackage" },
  { label: "Paint Bucket", value: "FeatherPaintBucket" },
  { label: "Paint Roller", value: "FeatherPaintRoller" },
  { label: "Paintbrush 2", value: "FeatherPaintbrush2" },
  { label: "Paintbrush Vertical", value: "FeatherPaintbrushVertical" },
  { label: "Paintbrush", value: "FeatherPaintbrush" },
  { label: "Palette", value: "FeatherPalette" },
  { label: "Palmtree", value: "FeatherPalmtree" },
  { label: "Panda", value: "FeatherPanda" },
  { label: "Panel Bottom Close", value: "FeatherPanelBottomClose" },
  { label: "Panel Bottom Inactive", value: "FeatherPanelBottomInactive" },
  { label: "Panel Bottom Open", value: "FeatherPanelBottomOpen" },
  { label: "Panel Bottom", value: "FeatherPanelBottom" },
  { label: "Panel Left Close", value: "FeatherPanelLeftClose" },
  { label: "Panel Left Inactive", value: "FeatherPanelLeftInactive" },
  { label: "Panel Left Open", value: "FeatherPanelLeftOpen" },
  { label: "Panel Left", value: "FeatherPanelLeft" },
  { label: "Panel Right Close", value: "FeatherPanelRightClose" },
  { label: "Panel Right Inactive", value: "FeatherPanelRightInactive" },
  { label: "Panel Right Open", value: "FeatherPanelRightOpen" },
  { label: "Panel Right", value: "FeatherPanelRight" },
  { label: "Panel Top Close", value: "FeatherPanelTopClose" },
  { label: "Panel Top Inactive", value: "FeatherPanelTopInactive" },
  { label: "Panel Top Open", value: "FeatherPanelTopOpen" },
  { label: "Panel Top", value: "FeatherPanelTop" },
  { label: "Panels Left Bottom", value: "FeatherPanelsLeftBottom" },
  { label: "Panels Right Bottom", value: "FeatherPanelsRightBottom" },
  { label: "Panels Top Left", value: "FeatherPanelsTopLeft" },
  { label: "Paperclip", value: "FeatherPaperclip" },
  { label: "Parentheses", value: "FeatherParentheses" },
  { label: "Parking Circle Off", value: "FeatherParkingCircleOff" },
  { label: "Parking Circle", value: "FeatherParkingCircle" },
  { label: "Parking Meter", value: "FeatherParkingMeter" },
  { label: "Parking Square Off", value: "FeatherParkingSquareOff" },
  { label: "Parking Square", value: "FeatherParkingSquare" },
  { label: "Party Popper", value: "FeatherPartyPopper" },
  { label: "Pause Circle", value: "FeatherPauseCircle" },
  { label: "Pause Octagon", value: "FeatherPauseOctagon" },
  { label: "Pause", value: "FeatherPause" },
  { label: "Paw Print", value: "FeatherPawPrint" },
  { label: "Pc Case", value: "FeatherPcCase" },
  { label: "Pen Line", value: "FeatherPenLine" },
  { label: "Pen Off", value: "FeatherPenOff" },
  { label: "Pen Square", value: "FeatherPenSquare" },
  { label: "Pen Tool", value: "FeatherPenTool" },
  { label: "Pen", value: "FeatherPen" },
  { label: "Pencil Line", value: "FeatherPencilLine" },
  { label: "Pencil Off", value: "FeatherPencilOff" },
  { label: "Pencil Ruler", value: "FeatherPencilRuler" },
  { label: "Pencil", value: "FeatherPencil" },
  { label: "Pentagon", value: "FeatherPentagon" },
  { label: "Percent Circle", value: "FeatherPercentCircle" },
  { label: "Percent Diamond", value: "FeatherPercentDiamond" },
  { label: "Percent Square", value: "FeatherPercentSquare" },
  { label: "Percent", value: "FeatherPercent" },
  { label: "Person Standing", value: "FeatherPersonStanding" },
  { label: "Philippine Peso", value: "FeatherPhilippinePeso" },
  { label: "Phone Call", value: "FeatherPhoneCall" },
  { label: "Phone Forwarded", value: "FeatherPhoneForwarded" },
  { label: "Phone Incoming", value: "FeatherPhoneIncoming" },
  { label: "Phone Missed", value: "FeatherPhoneMissed" },
  { label: "Phone Off", value: "FeatherPhoneOff" },
  { label: "Phone Outgoing", value: "FeatherPhoneOutgoing" },
  { label: "Phone", value: "FeatherPhone" },
  { label: "Pi Square", value: "FeatherPiSquare" },
  { label: "Pi", value: "FeatherPi" },
  { label: "Piano", value: "FeatherPiano" },
  { label: "Pickaxe", value: "FeatherPickaxe" },
  { label: "Picture In Picture 2", value: "FeatherPictureInPicture2" },
  { label: "Picture In Picture", value: "FeatherPictureInPicture" },
  { label: "Pie Chart", value: "FeatherPieChart" },
  { label: "Piggy Bank", value: "FeatherPiggyBank" },
  { label: "Pilcrow Left", value: "FeatherPilcrowLeft" },
  { label: "Pilcrow Right", value: "FeatherPilcrowRight" },
  { label: "Pilcrow Square", value: "FeatherPilcrowSquare" },
  { label: "Pilcrow", value: "FeatherPilcrow" },
  { label: "Pill Bottle", value: "FeatherPillBottle" },
  { label: "Pill", value: "FeatherPill" },
  { label: "Pin Off", value: "FeatherPinOff" },
  { label: "Pin", value: "FeatherPin" },
  { label: "Pipette", value: "FeatherPipette" },
  { label: "Pizza", value: "FeatherPizza" },
  { label: "Plane Landing", value: "FeatherPlaneLanding" },
  { label: "Plane Takeoff", value: "FeatherPlaneTakeoff" },
  { label: "Plane", value: "FeatherPlane" },
  { label: "Play Circle", value: "FeatherPlayCircle" },
  { label: "Play Square", value: "FeatherPlaySquare" },
  { label: "Play", value: "FeatherPlay" },
  { label: "Plug 2", value: "FeatherPlug2" },
  { label: "Plug Zap 2", value: "FeatherPlugZap2" },
  { label: "Plug Zap", value: "FeatherPlugZap" },
  { label: "Plug", value: "FeatherPlug" },
  { label: "Plus Circle", value: "FeatherPlusCircle" },
  { label: "Plus Square", value: "FeatherPlusSquare" },
  { label: "Plus", value: "FeatherPlus" },
  { label: "Pocket Knife", value: "FeatherPocketKnife" },
  { label: "Pocket", value: "FeatherPocket" },
  { label: "Podcast", value: "FeatherPodcast" },
  { label: "Pointer Off", value: "FeatherPointerOff" },
  { label: "Pointer", value: "FeatherPointer" },
  { label: "Popcorn", value: "FeatherPopcorn" },
  { label: "Popsicle", value: "FeatherPopsicle" },
  { label: "Pound Sterling", value: "FeatherPoundSterling" },
  { label: "Power Circle", value: "FeatherPowerCircle" },
  { label: "Power Off", value: "FeatherPowerOff" },
  { label: "Power Square", value: "FeatherPowerSquare" },
  { label: "Power", value: "FeatherPower" },
  { label: "Presentation", value: "FeatherPresentation" },
  { label: "Printer Check", value: "FeatherPrinterCheck" },
  { label: "Printer", value: "FeatherPrinter" },
  { label: "Projector", value: "FeatherProjector" },
  { label: "Proportions", value: "FeatherProportions" },
  { label: "Puzzle", value: "FeatherPuzzle" },
  { label: "Pyramid", value: "FeatherPyramid" },
  { label: "Qr Code", value: "FeatherQrCode" },
  { label: "Quote", value: "FeatherQuote" },
  { label: "Rabbit", value: "FeatherRabbit" },
  { label: "Radar", value: "FeatherRadar" },
  { label: "Radiation", value: "FeatherRadiation" },
  { label: "Radical", value: "FeatherRadical" },
  { label: "Radio Receiver", value: "FeatherRadioReceiver" },
  { label: "Radio Tower", value: "FeatherRadioTower" },
  { label: "Radio", value: "FeatherRadio" },
  { label: "Radius", value: "FeatherRadius" },
  { label: "Rail Symbol", value: "FeatherRailSymbol" },
  { label: "Rainbow", value: "FeatherRainbow" },
  { label: "Rat", value: "FeatherRat" },
  { label: "Ratio", value: "FeatherRatio" },
  { label: "Receipt Cent", value: "FeatherReceiptCent" },
  { label: "Receipt Euro", value: "FeatherReceiptEuro" },
  { label: "Receipt Indian Rupee", value: "FeatherReceiptIndianRupee" },
  { label: "Receipt Japanese Yen", value: "FeatherReceiptJapaneseYen" },
  { label: "Receipt Pound Sterling", value: "FeatherReceiptPoundSterling" },
  { label: "Receipt Russian Ruble", value: "FeatherReceiptRussianRuble" },
  { label: "Receipt Swiss Franc", value: "FeatherReceiptSwissFranc" },
  { label: "Receipt Text", value: "FeatherReceiptText" },
  { label: "Receipt", value: "FeatherReceipt" },
  { label: "Rectangle Circle", value: "FeatherRectangleCircle" },
  { label: "Rectangle Goggles", value: "FeatherRectangleGoggles" },
  { label: "Rectangle Horizontal", value: "FeatherRectangleHorizontal" },
  { label: "Rectangle Vertical", value: "FeatherRectangleVertical" },
  { label: "Recycle", value: "FeatherRecycle" },
  { label: "Redo 2", value: "FeatherRedo2" },
  { label: "Redo Dot", value: "FeatherRedoDot" },
  { label: "Redo", value: "FeatherRedo" },
  { label: "Refresh Ccw Dot", value: "FeatherRefreshCcwDot" },
  { label: "Refresh Ccw", value: "FeatherRefreshCcw" },
  { label: "Refresh Cw Off", value: "FeatherRefreshCwOff" },
  { label: "Refresh Cw", value: "FeatherRefreshCw" },
  { label: "Refrigerator", value: "FeatherRefrigerator" },
  { label: "Regex", value: "FeatherRegex" },
  { label: "Remove Formatting", value: "FeatherRemoveFormatting" },
  { label: "Repeat 1", value: "FeatherRepeat1" },
  { label: "Repeat 2", value: "FeatherRepeat2" },
  { label: "Repeat", value: "FeatherRepeat" },
  { label: "Replace All", value: "FeatherReplaceAll" },
  { label: "Replace", value: "FeatherReplace" },
  { label: "Reply All", value: "FeatherReplyAll" },
  { label: "Reply", value: "FeatherReply" },
  { label: "Rewind", value: "FeatherRewind" },
  { label: "Ribbon", value: "FeatherRibbon" },
  { label: "Rocket", value: "FeatherRocket" },
  { label: "Rocking Chair", value: "FeatherRockingChair" },
  { label: "Roller Coaster", value: "FeatherRollerCoaster" },
  { label: "Rotate 3d", value: "FeatherRotate3D" },
  { label: "Rotate Ccw Key", value: "FeatherRotateCcwKey" },
  { label: "Rotate Ccw Square", value: "FeatherRotateCcwSquare" },
  { label: "Rotate Ccw", value: "FeatherRotateCcw" },
  { label: "Rotate Cw Square", value: "FeatherRotateCwSquare" },
  { label: "Rotate Cw", value: "FeatherRotateCw" },
  { label: "Route Off", value: "FeatherRouteOff" },
  { label: "Route", value: "FeatherRoute" },
  { label: "Router", value: "FeatherRouter" },
  { label: "Rows 2", value: "FeatherRows2" },
  { label: "Rows 3", value: "FeatherRows3" },
  { label: "Rows 4", value: "FeatherRows4" },
  { label: "Rows", value: "FeatherRows" },
  { label: "Rss", value: "FeatherRss" },
  { label: "Ruler Dimension Line", value: "FeatherRulerDimensionLine" },
  { label: "Ruler", value: "FeatherRuler" },
  { label: "Russian Ruble", value: "FeatherRussianRuble" },
  { label: "Sailboat", value: "FeatherSailboat" },
  { label: "Salad", value: "FeatherSalad" },
  { label: "Sandwich", value: "FeatherSandwich" },
  { label: "Satellite Dish", value: "FeatherSatelliteDish" },
  { label: "Satellite", value: "FeatherSatellite" },
  { label: "Saudi Riyal", value: "FeatherSaudiRiyal" },
  { label: "Save All", value: "FeatherSaveAll" },
  { label: "Save Off", value: "FeatherSaveOff" },
  { label: "Save", value: "FeatherSave" },
  { label: "Scale 3d", value: "FeatherScale3D" },
  { label: "Scale", value: "FeatherScale" },
  { label: "Scaling", value: "FeatherScaling" },
  { label: "Scan Barcode", value: "FeatherScanBarcode" },
  { label: "Scan Eye", value: "FeatherScanEye" },
  { label: "Scan Face", value: "FeatherScanFace" },
  { label: "Scan Heart", value: "FeatherScanHeart" },
  { label: "Scan Line", value: "FeatherScanLine" },
  { label: "Scan Qr Code", value: "FeatherScanQrCode" },
  { label: "Scan Search", value: "FeatherScanSearch" },
  { label: "Scan Text", value: "FeatherScanText" },
  { label: "Scan", value: "FeatherScan" },
  { label: "Scatter Chart", value: "FeatherScatterChart" },
  { label: "School 2", value: "FeatherSchool2" },
  { label: "School", value: "FeatherSchool" },
  { label: "Scissors Line Dashed", value: "FeatherScissorsLineDashed" },
  {
    label: "Scissors Square Dashed Bottom",
    value: "FeatherScissorsSquareDashedBottom",
  },
  { label: "Scissors Square", value: "FeatherScissorsSquare" },
  { label: "Scissors", value: "FeatherScissors" },
  { label: "Screen Share Off", value: "FeatherScreenShareOff" },
  { label: "Screen Share", value: "FeatherScreenShare" },
  { label: "Scroll Text", value: "FeatherScrollText" },
  { label: "Scroll", value: "FeatherScroll" },
  { label: "Search Check", value: "FeatherSearchCheck" },
  { label: "Search Code", value: "FeatherSearchCode" },
  { label: "Search Slash", value: "FeatherSearchSlash" },
  { label: "Search X", value: "FeatherSearchX" },
  { label: "Search", value: "FeatherSearch" },
  { label: "Section", value: "FeatherSection" },
  { label: "Send Horizontal", value: "FeatherSendHorizontal" },
  { label: "Send To Back", value: "FeatherSendToBack" },
  { label: "Send", value: "FeatherSend" },
  { label: "Separator Horizontal", value: "FeatherSeparatorHorizontal" },
  { label: "Separator Vertical", value: "FeatherSeparatorVertical" },
  { label: "Server Cog", value: "FeatherServerCog" },
  { label: "Server Crash", value: "FeatherServerCrash" },
  { label: "Server Off", value: "FeatherServerOff" },
  { label: "Server", value: "FeatherServer" },
  { label: "Settings 2", value: "FeatherSettings2" },
  { label: "Settings", value: "FeatherSettings" },
  { label: "Shadow Large", value: "FeatherShadowLarge" },
  { label: "Shadow Medium", value: "FeatherShadowMedium" },
  { label: "Shadow Small", value: "FeatherShadowSmall" },
  { label: "Shapes", value: "FeatherShapes" },
  { label: "Share 2", value: "FeatherShare2" },
  { label: "Share", value: "FeatherShare" },
  { label: "Sheet", value: "FeatherSheet" },
  { label: "Shell", value: "FeatherShell" },
  { label: "Shield Alert", value: "FeatherShieldAlert" },
  { label: "Shield Ban", value: "FeatherShieldBan" },
  { label: "Shield Check", value: "FeatherShieldCheck" },
  { label: "Shield Close", value: "FeatherShieldClose" },
  { label: "Shield Ellipsis", value: "FeatherShieldEllipsis" },
  { label: "Shield Half", value: "FeatherShieldHalf" },
  { label: "Shield Minus", value: "FeatherShieldMinus" },
  { label: "Shield Off", value: "FeatherShieldOff" },
  { label: "Shield Plus", value: "FeatherShieldPlus" },
  { label: "Shield Question Mark", value: "FeatherShieldQuestionMark" },
  { label: "Shield Question", value: "FeatherShieldQuestion" },
  { label: "Shield User", value: "FeatherShieldUser" },
  { label: "Shield X", value: "FeatherShieldX" },
  { label: "Shield", value: "FeatherShield" },
  { label: "Ship Wheel", value: "FeatherShipWheel" },
  { label: "Ship", value: "FeatherShip" },
  { label: "Shirt", value: "FeatherShirt" },
  { label: "Shopping Bag", value: "FeatherShoppingBag" },
  { label: "Shopping Basket", value: "FeatherShoppingBasket" },
  { label: "Shopping Cart", value: "FeatherShoppingCart" },
  { label: "Shovel", value: "FeatherShovel" },
  { label: "Shower Head", value: "FeatherShowerHead" },
  { label: "Shredder", value: "FeatherShredder" },
  { label: "Shrimp", value: "FeatherShrimp" },
  { label: "Shrink", value: "FeatherShrink" },
  { label: "Shrub", value: "FeatherShrub" },
  { label: "Shuffle", value: "FeatherShuffle" },
  { label: "Sidebar Close", value: "FeatherSidebarClose" },
  { label: "Sidebar Open", value: "FeatherSidebarOpen" },
  { label: "Sidebar", value: "FeatherSidebar" },
  { label: "Sigma Square", value: "FeatherSigmaSquare" },
  { label: "Sigma", value: "FeatherSigma" },
  { label: "Signal High", value: "FeatherSignalHigh" },
  { label: "Signal Low", value: "FeatherSignalLow" },
  { label: "Signal Medium", value: "FeatherSignalMedium" },
  { label: "Signal Zero", value: "FeatherSignalZero" },
  { label: "Signal", value: "FeatherSignal" },
  { label: "Signature", value: "FeatherSignature" },
  { label: "Signpost Big", value: "FeatherSignpostBig" },
  { label: "Signpost", value: "FeatherSignpost" },
  { label: "Siren", value: "FeatherSiren" },
  { label: "Skip Back", value: "FeatherSkipBack" },
  { label: "Skip Forward", value: "FeatherSkipForward" },
  { label: "Skull", value: "FeatherSkull" },
  { label: "Slack", value: "FeatherSlack" },
  { label: "Slash", value: "FeatherSlash" },
  { label: "Slice", value: "FeatherSlice" },
  { label: "Sliders Horizontal", value: "FeatherSlidersHorizontal" },
  { label: "Sliders", value: "FeatherSliders" },
  { label: "Smartphone Charging", value: "FeatherSmartphoneCharging" },
  { label: "Smartphone Nfc", value: "FeatherSmartphoneNfc" },
  { label: "Smartphone", value: "FeatherSmartphone" },
  { label: "Smile Plus", value: "FeatherSmilePlus" },
  { label: "Smile", value: "FeatherSmile" },
  { label: "Snail", value: "FeatherSnail" },
  { label: "Snowflake", value: "FeatherSnowflake" },
  { label: "Soap Dispenser Droplet", value: "FeatherSoapDispenserDroplet" },
  { label: "Sofa", value: "FeatherSofa" },
  { label: "Sort Asc", value: "FeatherSortAsc" },
  { label: "Sort Desc", value: "FeatherSortDesc" },
  { label: "Soup", value: "FeatherSoup" },
  { label: "Space", value: "FeatherSpace" },
  { label: "Spade", value: "FeatherSpade" },
  { label: "Sparkle", value: "FeatherSparkle" },
  { label: "Sparkles", value: "FeatherSparkles" },
  { label: "Speaker", value: "FeatherSpeaker" },
  { label: "Speech", value: "FeatherSpeech" },
  { label: "Spell Check 2", value: "FeatherSpellCheck2" },
  { label: "Spell Check", value: "FeatherSpellCheck" },
  { label: "Spline Pointer", value: "FeatherSplinePointer" },
  { label: "Spline", value: "FeatherSpline" },
  { label: "Split Square Horizontal", value: "FeatherSplitSquareHorizontal" },
  { label: "Split Square Vertical", value: "FeatherSplitSquareVertical" },
  { label: "Split", value: "FeatherSplit" },
  { label: "Spool", value: "FeatherSpool" },
  { label: "Spray Can", value: "FeatherSprayCan" },
  { label: "Sprout", value: "FeatherSprout" },
  {
    label: "Square Arrow Out Down Left",
    value: "FeatherSquareArrowOutDownLeft",
  },
  {
    label: "Square Arrow Out Down Right",
    value: "FeatherSquareArrowOutDownRight",
  },
  { label: "Square Arrow Out Up Left", value: "FeatherSquareArrowOutUpLeft" },
  { label: "Square Arrow Out Up Right", value: "FeatherSquareArrowOutUpRight" },
  { label: "Square Asterisk", value: "FeatherSquareAsterisk" },
  { label: "Square Check Big", value: "FeatherSquareCheckBig" },
  { label: "Square Check", value: "FeatherSquareCheck" },
  { label: "Square Code", value: "FeatherSquareCode" },
  { label: "Square Corner Bl", value: "FeatherSquareCornerBl" },
  { label: "Square Corner Br Bl", value: "FeatherSquareCornerBrBl" },
  { label: "Square Corner Br", value: "FeatherSquareCornerBr" },
  { label: "Square Corner Tl Bl", value: "FeatherSquareCornerTlBl" },
  { label: "Square Corner Tl Br Bl", value: "FeatherSquareCornerTlBrBl" },
  { label: "Square Corner Tl Br", value: "FeatherSquareCornerTlBr" },
  { label: "Square Corner Tl Tr Bl", value: "FeatherSquareCornerTlTrBl" },
  { label: "Square Corner Tl Tr Br", value: "FeatherSquareCornerTlTrBr" },
  { label: "Square Corner Tl", value: "FeatherSquareCornerTl" },
  { label: "Square Corner Tr Bl", value: "FeatherSquareCornerTrBl" },
  { label: "Square Corner Tr Br Bl", value: "FeatherSquareCornerTrBrBl" },
  { label: "Square Corner Tr Br", value: "FeatherSquareCornerTrBr" },
  { label: "Square Corner Tr Tl", value: "FeatherSquareCornerTrTl" },
  { label: "Square Corner Tr", value: "FeatherSquareCornerTr" },
  { label: "Square Corner", value: "FeatherSquareCorner" },
  {
    label: "Square Dashed Bottom Code",
    value: "FeatherSquareDashedBottomCode",
  },
  { label: "Square Dashed Bottom", value: "FeatherSquareDashedBottom" },
  {
    label: "Square Dashed Mouse Pointer",
    value: "FeatherSquareDashedMousePointer",
  },
  { label: "Square Dashed Top Solid", value: "FeatherSquareDashedTopSolid" },
  { label: "Square Dot", value: "FeatherSquareDot" },
  { label: "Square Equal", value: "FeatherSquareEqual" },
  { label: "Square Mouse Pointer", value: "FeatherSquareMousePointer" },
  { label: "Square Pen", value: "FeatherSquarePen" },
  { label: "Square Power", value: "FeatherSquarePower" },
  { label: "Square Radical", value: "FeatherSquareRadical" },
  { label: "Square Round Corner", value: "FeatherSquareRoundCorner" },
  { label: "Square Sides Bottom", value: "FeatherSquareSidesBottom" },
  { label: "Square Sides Left Bottom", value: "FeatherSquareSidesLeftBottom" },
  {
    label: "Square Sides Left Right Bottom",
    value: "FeatherSquareSidesLeftRightBottom",
  },
  { label: "Square Sides Left Right", value: "FeatherSquareSidesLeftRight" },
  {
    label: "Square Sides Left Top Bottom",
    value: "FeatherSquareSidesLeftTopBottom",
  },
  {
    label: "Square Sides Left Top Right",
    value: "FeatherSquareSidesLeftTopRight",
  },
  { label: "Square Sides Left Top", value: "FeatherSquareSidesLeftTop" },
  { label: "Square Sides Left", value: "FeatherSquareSidesLeft" },
  {
    label: "Square Sides Right Bottom",
    value: "FeatherSquareSidesRightBottom",
  },
  { label: "Square Sides Right", value: "FeatherSquareSidesRight" },
  { label: "Square Sides Top Bottom", value: "FeatherSquareSidesTopBottom" },
  {
    label: "Square Sides Top Right Bottom",
    value: "FeatherSquareSidesTopRightBottom",
  },
  { label: "Square Sides Top Right", value: "FeatherSquareSidesTopRight" },
  { label: "Square Sides Top", value: "FeatherSquareSidesTop" },
  { label: "Square Sides", value: "FeatherSquareSides" },
  { label: "Square Slash", value: "FeatherSquareSlash" },
  { label: "Square Square", value: "FeatherSquareSquare" },
  { label: "Square Stack", value: "FeatherSquareStack" },
  { label: "Square", value: "FeatherSquare" },
  { label: "Squares Exclude", value: "FeatherSquaresExclude" },
  { label: "Squares Intersect", value: "FeatherSquaresIntersect" },
  { label: "Squares Subtract", value: "FeatherSquaresSubtract" },
  { label: "Squares Unite", value: "FeatherSquaresUnite" },
  { label: "Squircle Dashed", value: "FeatherSquircleDashed" },
  { label: "Squircle", value: "FeatherSquircle" },
  { label: "Squirrel", value: "FeatherSquirrel" },
  { label: "Stamp", value: "FeatherStamp" },
  { label: "Star Half", value: "FeatherStarHalf" },
  { label: "Star Off", value: "FeatherStarOff" },
  { label: "Star", value: "FeatherStar" },
  { label: "Step Back", value: "FeatherStepBack" },
  { label: "Step Forward", value: "FeatherStepForward" },
  { label: "Stethoscope", value: "FeatherStethoscope" },
  { label: "Sticker", value: "FeatherSticker" },
  { label: "Sticky Note", value: "FeatherStickyNote" },
  { label: "Stop Circle", value: "FeatherStopCircle" },
  { label: "Store", value: "FeatherStore" },
  { label: "Stretch Horizontal", value: "FeatherStretchHorizontal" },
  { label: "Stretch Vertical", value: "FeatherStretchVertical" },
  { label: "Strikethrough", value: "FeatherStrikethrough" },
  { label: "Subframe", value: "FeatherSubframe" },
  { label: "Subscript", value: "FeatherSubscript" },
  { label: "Subtitles", value: "FeatherSubtitles" },
  { label: "Sun Dim", value: "FeatherSunDim" },
  { label: "Sun Medium", value: "FeatherSunMedium" },
  { label: "Sun Moon", value: "FeatherSunMoon" },
  { label: "Sun Snow", value: "FeatherSunSnow" },
  { label: "Sun", value: "FeatherSun" },
  { label: "Sunrise", value: "FeatherSunrise" },
  { label: "Sunset", value: "FeatherSunset" },
  { label: "Superscript", value: "FeatherSuperscript" },
  { label: "Swatch Book", value: "FeatherSwatchBook" },
  { label: "Swiss Franc", value: "FeatherSwissFranc" },
  { label: "Switch Camera", value: "FeatherSwitchCamera" },
  { label: "Sword", value: "FeatherSword" },
  { label: "Swords", value: "FeatherSwords" },
  { label: "Syringe", value: "FeatherSyringe" },
  { label: "Table 2", value: "FeatherTable2" },
  { label: "Table Cells Merge", value: "FeatherTableCellsMerge" },
  { label: "Table Cells Split", value: "FeatherTableCellsSplit" },
  { label: "Table Columns Split", value: "FeatherTableColumnsSplit" },
  { label: "Table Of Contents", value: "FeatherTableOfContents" },
  { label: "Table Properties", value: "FeatherTableProperties" },
  { label: "Table Rows Split", value: "FeatherTableRowsSplit" },
  { label: "Table", value: "FeatherTable" },
  { label: "Tablet Smartphone", value: "FeatherTabletSmartphone" },
  { label: "Tablet", value: "FeatherTablet" },
  { label: "Tablets", value: "FeatherTablets" },
  { label: "Tag", value: "FeatherTag" },
  { label: "Tags", value: "FeatherTags" },
  { label: "Tally 1", value: "FeatherTally1" },
  { label: "Tally 2", value: "FeatherTally2" },
  { label: "Tally 3", value: "FeatherTally3" },
  { label: "Tally 4", value: "FeatherTally4" },
  { label: "Tally 5", value: "FeatherTally5" },
  { label: "Tangent", value: "FeatherTangent" },
  { label: "Target", value: "FeatherTarget" },
  { label: "Telescope", value: "FeatherTelescope" },
  { label: "Tent Tree", value: "FeatherTentTree" },
  { label: "Tent", value: "FeatherTent" },
  { label: "Terminal Square", value: "FeatherTerminalSquare" },
  { label: "Terminal", value: "FeatherTerminal" },
  { label: "Test Tube 2", value: "FeatherTestTube2" },
  { label: "Test Tube Diagonal", value: "FeatherTestTubeDiagonal" },
  { label: "Test Tube", value: "FeatherTestTube" },
  { label: "Test Tubes", value: "FeatherTestTubes" },
  { label: "Text Cursor Input", value: "FeatherTextCursorInput" },
  { label: "Text Cursor", value: "FeatherTextCursor" },
  { label: "Text Quote", value: "FeatherTextQuote" },
  { label: "Text Search", value: "FeatherTextSearch" },
  { label: "Text Select", value: "FeatherTextSelect" },
  { label: "Text Size", value: "FeatherTextSize" },
  { label: "Text Truncate", value: "FeatherTextTruncate" },
  { label: "Text", value: "FeatherText" },
  { label: "Theater", value: "FeatherTheater" },
  { label: "Thermometer Snowflake", value: "FeatherThermometerSnowflake" },
  { label: "Thermometer Sun", value: "FeatherThermometerSun" },
  { label: "Thermometer", value: "FeatherThermometer" },
  { label: "Thumbs Down", value: "FeatherThumbsDown" },
  { label: "Thumbs Up", value: "FeatherThumbsUp" },
  { label: "Ticket Check", value: "FeatherTicketCheck" },
  { label: "Ticket Minus", value: "FeatherTicketMinus" },
  { label: "Ticket Percent", value: "FeatherTicketPercent" },
  { label: "Ticket Plus", value: "FeatherTicketPlus" },
  { label: "Ticket Slash", value: "FeatherTicketSlash" },
  { label: "Ticket X", value: "FeatherTicketX" },
  { label: "Ticket", value: "FeatherTicket" },
  { label: "Tickets Plane", value: "FeatherTicketsPlane" },
  { label: "Tickets", value: "FeatherTickets" },
  { label: "Timer Off", value: "FeatherTimerOff" },
  { label: "Timer Reset", value: "FeatherTimerReset" },
  { label: "Timer", value: "FeatherTimer" },
  { label: "Toggle Left", value: "FeatherToggleLeft" },
  { label: "Toggle Right", value: "FeatherToggleRight" },
  { label: "Toilet", value: "FeatherToilet" },
  { label: "Tool", value: "FeatherTool" },
  { label: "Tornado", value: "FeatherTornado" },
  { label: "Torus", value: "FeatherTorus" },
  { label: "Touchpad Off", value: "FeatherTouchpadOff" },
  { label: "Touchpad", value: "FeatherTouchpad" },
  { label: "Tower Control", value: "FeatherTowerControl" },
  { label: "Toy Brick", value: "FeatherToyBrick" },
  { label: "Tractor", value: "FeatherTractor" },
  { label: "Traffic Cone", value: "FeatherTrafficCone" },
  { label: "Train Front Tunnel", value: "FeatherTrainFrontTunnel" },
  { label: "Train Front", value: "FeatherTrainFront" },
  { label: "Train Track", value: "FeatherTrainTrack" },
  { label: "Train", value: "FeatherTrain" },
  { label: "Tram Front", value: "FeatherTramFront" },
  { label: "Transgender", value: "FeatherTransgender" },
  { label: "Trash 2", value: "FeatherTrash2" },
  { label: "Trash", value: "FeatherTrash" },
  { label: "Tree Deciduous", value: "FeatherTreeDeciduous" },
  { label: "Tree Palm", value: "FeatherTreePalm" },
  { label: "Tree Pine", value: "FeatherTreePine" },
  { label: "Trees", value: "FeatherTrees" },
  { label: "Trello", value: "FeatherTrello" },
  { label: "Trending Down", value: "FeatherTrendingDown" },
  { label: "Trending Up Down", value: "FeatherTrendingUpDown" },
  { label: "Trending Up", value: "FeatherTrendingUp" },
  { label: "Triangle Alert", value: "FeatherTriangleAlert" },
  { label: "Triangle Dashed", value: "FeatherTriangleDashed" },
  { label: "Triangle Right", value: "FeatherTriangleRight" },
  { label: "Triangle", value: "FeatherTriangle" },
  { label: "Trophy", value: "FeatherTrophy" },
  { label: "Truck Electric", value: "FeatherTruckElectric" },
  { label: "Truck", value: "FeatherTruck" },
  { label: "Turtle", value: "FeatherTurtle" },
  { label: "Tv 2", value: "FeatherTv2" },
  { label: "Tv Minimal Play", value: "FeatherTvMinimalPlay" },
  { label: "Tv", value: "FeatherTv" },
  { label: "Twitch", value: "FeatherTwitch" },
  { label: "Twitter", value: "FeatherTwitter" },
  { label: "Type Outline", value: "FeatherTypeOutline" },
  { label: "Type", value: "FeatherType" },
  { label: "Umbrella Off", value: "FeatherUmbrellaOff" },
  { label: "Umbrella", value: "FeatherUmbrella" },
  { label: "Underline", value: "FeatherUnderline" },
  { label: "Undo 2", value: "FeatherUndo2" },
  { label: "Undo Dot", value: "FeatherUndoDot" },
  { label: "Undo", value: "FeatherUndo" },
  { label: "Unfold Horizontal", value: "FeatherUnfoldHorizontal" },
  { label: "Unfold Vertical", value: "FeatherUnfoldVertical" },
  { label: "Ungroup", value: "FeatherUngroup" },
  { label: "University", value: "FeatherUniversity" },
  { label: "Unlink 2", value: "FeatherUnlink2" },
  { label: "Unlink", value: "FeatherUnlink" },
  { label: "Unlock Keyhole", value: "FeatherUnlockKeyhole" },
  { label: "Unlock", value: "FeatherUnlock" },
  { label: "Unplug", value: "FeatherUnplug" },
  { label: "Upload Cloud", value: "FeatherUploadCloud" },
  { label: "Upload", value: "FeatherUpload" },
  { label: "Usb", value: "FeatherUsb" },
  { label: "User 2", value: "FeatherUser2" },
  { label: "User Check 2", value: "FeatherUserCheck2" },
  { label: "User Check", value: "FeatherUserCheck" },
  { label: "User Circle 2", value: "FeatherUserCircle2" },
  { label: "User Circle", value: "FeatherUserCircle" },
  { label: "User Cog 2", value: "FeatherUserCog2" },
  { label: "User Cog", value: "FeatherUserCog" },
  { label: "User Lock", value: "FeatherUserLock" },
  { label: "User Minus 2", value: "FeatherUserMinus2" },
  { label: "User Minus", value: "FeatherUserMinus" },
  { label: "User Pen", value: "FeatherUserPen" },
  { label: "User Plus 2", value: "FeatherUserPlus2" },
  { label: "User Plus", value: "FeatherUserPlus" },
  { label: "User Round Check", value: "FeatherUserRoundCheck" },
  { label: "User Round Cog", value: "FeatherUserRoundCog" },
  { label: "User Round Minus", value: "FeatherUserRoundMinus" },
  { label: "User Round Pen", value: "FeatherUserRoundPen" },
  { label: "User Round Plus", value: "FeatherUserRoundPlus" },
  { label: "User Round Search", value: "FeatherUserRoundSearch" },
  { label: "User Round X", value: "FeatherUserRoundX" },
  { label: "User Round", value: "FeatherUserRound" },
  { label: "User Search", value: "FeatherUserSearch" },
  { label: "User Square 2", value: "FeatherUserSquare2" },
  { label: "User Square", value: "FeatherUserSquare" },
  { label: "User X 2", value: "FeatherUserX2" },
  { label: "User X", value: "FeatherUserX" },
  { label: "User", value: "FeatherUser" },
  { label: "Users 2", value: "FeatherUsers2" },
  { label: "Users Round", value: "FeatherUsersRound" },
  { label: "Users", value: "FeatherUsers" },
  { label: "Utensils Crossed", value: "FeatherUtensilsCrossed" },
  { label: "Utensils", value: "FeatherUtensils" },
  { label: "Utility Pole", value: "FeatherUtilityPole" },
  { label: "Variable", value: "FeatherVariable" },
  { label: "Vault", value: "FeatherVault" },
  { label: "Vegan", value: "FeatherVegan" },
  { label: "Venetian Mask", value: "FeatherVenetianMask" },
  { label: "Venus And Mars", value: "FeatherVenusAndMars" },
  { label: "Venus", value: "FeatherVenus" },
  { label: "Verified", value: "FeatherVerified" },
  { label: "Vibrate Off", value: "FeatherVibrateOff" },
  { label: "Vibrate", value: "FeatherVibrate" },
  { label: "Video Off", value: "FeatherVideoOff" },
  { label: "Video", value: "FeatherVideo" },
  { label: "Videotape", value: "FeatherVideotape" },
  { label: "View", value: "FeatherView" },
  { label: "Voicemail", value: "FeatherVoicemail" },
  { label: "Volleyball", value: "FeatherVolleyball" },
  { label: "Volume 1", value: "FeatherVolume1" },
  { label: "Volume 2", value: "FeatherVolume2" },
  { label: "Volume Off", value: "FeatherVolumeOff" },
  { label: "Volume X", value: "FeatherVolumeX" },
  { label: "Volume", value: "FeatherVolume" },
  { label: "Vote", value: "FeatherVote" },
  { label: "Wallet 2", value: "FeatherWallet2" },
  { label: "Wallet Cards", value: "FeatherWalletCards" },
  { label: "Wallet", value: "FeatherWallet" },
  { label: "Wallpaper", value: "FeatherWallpaper" },
  { label: "Wand 2", value: "FeatherWand2" },
  { label: "Wand Sparkles", value: "FeatherWandSparkles" },
  { label: "Wand", value: "FeatherWand" },
  { label: "Warehouse", value: "FeatherWarehouse" },
  { label: "Washing Machine", value: "FeatherWashingMachine" },
  { label: "Watch", value: "FeatherWatch" },
  { label: "Waves Ladder", value: "FeatherWavesLadder" },
  { label: "Waves", value: "FeatherWaves" },
  { label: "Waypoints", value: "FeatherWaypoints" },
  { label: "Webcam", value: "FeatherWebcam" },
  { label: "Webhook Off", value: "FeatherWebhookOff" },
  { label: "Webhook", value: "FeatherWebhook" },
  { label: "Weight", value: "FeatherWeight" },
  { label: "Wheat Off", value: "FeatherWheatOff" },
  { label: "Wheat", value: "FeatherWheat" },
  { label: "Whole Word", value: "FeatherWholeWord" },
  { label: "Wifi Cog", value: "FeatherWifiCog" },
  { label: "Wifi High", value: "FeatherWifiHigh" },
  { label: "Wifi Low", value: "FeatherWifiLow" },
  { label: "Wifi Off", value: "FeatherWifiOff" },
  { label: "Wifi Pen", value: "FeatherWifiPen" },
  { label: "Wifi Zero", value: "FeatherWifiZero" },
  { label: "Wifi", value: "FeatherWifi" },
  { label: "Wind Arrow Down", value: "FeatherWindArrowDown" },
  { label: "Wind", value: "FeatherWind" },
  { label: "Wine Off", value: "FeatherWineOff" },
  { label: "Wine", value: "FeatherWine" },
  { label: "Workflow", value: "FeatherWorkflow" },
  { label: "Worm", value: "FeatherWorm" },
  { label: "Wrap Text", value: "FeatherWrapText" },
  { label: "Wrench", value: "FeatherWrench" },
  { label: "X Circle", value: "FeatherXCircle" },
  { label: "X Octagon", value: "FeatherXOctagon" },
  { label: "X Square", value: "FeatherXSquare" },
  { label: "X Twitter", value: "FeatherXTwitter" },
  { label: "X", value: "FeatherX" },
  { label: "Youtube", value: "FeatherYoutube" },
  { label: "Zap Off", value: "FeatherZapOff" },
  { label: "Zap", value: "FeatherZap" },
  { label: "Zoom In", value: "FeatherZoomIn" },
  { label: "Zoom Out", value: "FeatherZoomOut" },
  { label: "Subframe Sides", value: "SubframeSides" },
  { label: "Empty", value: "null" },
] as const;
